"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable*/
// Do not edit!
// This file was auto-generated by create-sprites.js
exports.default = {
  "2614": [25, 7],
  "2615": [12, 28],
  "2648": [14, 0],
  "2649": [15, 0],
  "2650": [16, 0],
  "2651": [17, 0],
  "2652": [18, 0],
  "2653": [19, 0],
  "2693": [47, 29],
  "2705": [25, 0],
  "2728": [27, 7],
  "2753": [32, 0],
  "2754": [33, 0],
  "2755": [34, 0],
  "2757": [35, 0],
  "2795": [38, 0],
  "2796": [39, 0],
  "2797": [40, 0],
  "2049-fe0f": [0, 0],
  "2122-fe0f": [1, 0],
  "2139-fe0f": [2, 0],
  "2194-fe0f": [3, 0],
  "2195-fe0f": [4, 0],
  "2196-fe0f": [5, 0],
  "2197-fe0f": [6, 0],
  "2198-fe0f": [7, 0],
  "2199-fe0f": [8, 0],
  "2611-fe0f": [9, 0],
  "2622-fe0f": [10, 0],
  "2623-fe0f": [11, 0],
  "2626-fe0f": [12, 0],
  "2638-fe0f": [13, 0],
  "2660-fe0f": [20, 0],
  "2663-fe0f": [21, 0],
  "2665-fe0f": [22, 0],
  "2666-fe0f": [23, 0],
  "2668-fe0f": [24, 0],
  "2714-fe0f": [26, 0],
  "2716-fe0f": [27, 0],
  "2721-fe0f": [28, 0],
  "2733-fe0f": [29, 0],
  "2734-fe0f": [30, 0],
  "2747-fe0f": [31, 0],
  "2763-fe0f": [36, 0],
  "2764-fe0f": [37, 0],
  "2934-fe0f": [41, 0],
  "2935-fe0f": [42, 0],
  "3030-fe0f": [43, 0],
  "3297-fe0f": [44, 0],
  "3299-fe0f": [45, 0],
  "1f49b": [46, 0],
  "1f49a": [47, 0],
  "1f499": [48, 0],
  "1f49c": [49, 0],
  "1f5a4": [50, 0],
  "1f494": [51, 0],
  "1f495": [52, 0],
  "1f49e": [53, 0],
  "1f493": [54, 0],
  "1f497": [55, 0],
  "1f496": [56, 0],
  "1f498": [57, 0],
  "1f49d": [58, 0],
  "1f49f": [59, 0],
  "262e-fe0f": [60, 0],
  "271d-fe0f": [61, 0],
  "262a-fe0f": [62, 0],
  "1f549-fe0f": [63, 0],
  "1f52f": [0, 1],
  "1f54e": [1, 1],
  "262f-fe0f": [2, 1],
  "1f6d0": [3, 1],
  "26ce": [4, 1],
  "264a": [5, 1],
  "264b": [6, 1],
  "264c": [7, 1],
  "264d": [8, 1],
  "264e": [9, 1],
  "264f": [10, 1],
  "1f194": [11, 1],
  "269b-fe0f": [12, 1],
  "1f251": [13, 1],
  "1f4f4": [14, 1],
  "1f4f3": [15, 1],
  "1f236": [16, 1],
  "1f21a": [17, 1],
  "1f238": [18, 1],
  "1f23a": [19, 1],
  "1f237-fe0f": [20, 1],
  "1f19a": [21, 1],
  "1f4ae": [22, 1],
  "1f250": [23, 1],
  "1f234": [24, 1],
  "1f235": [25, 1],
  "1f239": [26, 1],
  "1f232": [27, 1],
  "1f170-fe0f": [28, 1],
  "1f171-fe0f": [29, 1],
  "1f18e": [30, 1],
  "1f191": [31, 1],
  "1f17e-fe0f": [32, 1],
  "1f198": [33, 1],
  "274c": [34, 1],
  "2b55": [35, 1],
  "1f6d1": [36, 1],
  "26d4": [37, 1],
  "1f4db": [38, 1],
  "1f6ab": [39, 1],
  "1f4af": [40, 1],
  "1f4a2": [41, 1],
  "1f6b7": [42, 1],
  "1f6af": [43, 1],
  "1f6b3": [44, 1],
  "1f6b1": [45, 1],
  "1f51e": [46, 1],
  "1f4f5": [47, 1],
  "1f6ad": [48, 1],
  "203c-fe0f": [49, 1],
  "1f505": [50, 1],
  "1f506": [51, 1],
  "303d-fe0f": [52, 1],
  "26a0-fe0f": [53, 1],
  "1f6b8": [54, 1],
  "1f531": [55, 1],
  "269c-fe0f": [56, 1],
  "1f530": [57, 1],
  "267b-fe0f": [58, 1],
  "1f22f": [59, 1],
  "1f4b9": [60, 1],
  "274e": [61, 1],
  "1f310": [62, 1],
  "1f4a0": [63, 1],
  "24c2-fe0f": [0, 2],
  "1f300": [1, 2],
  "1f4a4": [2, 2],
  "1f3e7": [3, 2],
  "1f6be": [4, 2],
  "267f": [5, 2],
  "1f17f-fe0f": [6, 2],
  "1f233": [7, 2],
  "1f202-fe0f": [8, 2],
  "1f6c2": [9, 2],
  "1f6c3": [10, 2],
  "1f6c4": [11, 2],
  "1f6c5": [12, 2],
  "1f6b9": [13, 2],
  "1f6ba": [14, 2],
  "1f6bc": [15, 2],
  "1f6bb": [16, 2],
  "1f6ae": [17, 2],
  "1f3a6": [18, 2],
  "1f4f6": [19, 2],
  "1f201": [20, 2],
  "1f523": [21, 2],
  "1f524": [22, 2],
  "1f521": [23, 2],
  "1f520": [24, 2],
  "1f196": [25, 2],
  "1f197": [26, 2],
  "1f199": [27, 2],
  "1f192": [28, 2],
  "1f195": [29, 2],
  "1f193": [30, 2],
  "0030-fe0f-20e3": [31, 2],
  "0031-fe0f-20e3": [32, 2],
  "0032-fe0f-20e3": [33, 2],
  "0033-fe0f-20e3": [34, 2],
  "0034-fe0f-20e3": [35, 2],
  "0035-fe0f-20e3": [36, 2],
  "0036-fe0f-20e3": [37, 2],
  "0037-fe0f-20e3": [38, 2],
  "0038-fe0f-20e3": [39, 2],
  "0039-fe0f-20e3": [40, 2],
  "1f51f": [41, 2],
  "1f522": [42, 2],
  "0023-fe0f-20e3": [43, 2],
  "002a-fe0f-20e3": [44, 2],
  "25b6-fe0f": [45, 2],
  "23f8-fe0f": [46, 2],
  "23ef-fe0f": [47, 2],
  "23f9-fe0f": [48, 2],
  "23fa-fe0f": [49, 2],
  "23cf-fe0f": [50, 2],
  "23ed-fe0f": [51, 2],
  "23ee-fe0f": [52, 2],
  "23e9": [53, 2],
  "23ea": [54, 2],
  "23eb": [55, 2],
  "23ec": [56, 2],
  "25c0-fe0f": [57, 2],
  "1f53c": [58, 2],
  "1f53d": [59, 2],
  "27a1-fe0f": [60, 2],
  "2b05-fe0f": [61, 2],
  "2b06-fe0f": [62, 2],
  "2b07-fe0f": [63, 2],
  "21aa-fe0f": [0, 3],
  "21a9-fe0f": [1, 3],
  "1f500": [2, 3],
  "1f501": [3, 3],
  "1f502": [4, 3],
  "1f504": [5, 3],
  "1f503": [6, 3],
  "1f3b5": [7, 3],
  "1f3b6": [8, 3],
  "1f4b2": [9, 3],
  "1f4b1": [10, 3],
  "00a9-fe0f": [11, 3],
  "00ae-fe0f": [12, 3],
  "27b0": [13, 3],
  "27bf": [14, 3],
  "1f51a": [15, 3],
  "1f519": [16, 3],
  "1f51b": [17, 3],
  "1f51d": [18, 3],
  "1f51c": [19, 3],
  "1f518": [20, 3],
  "26aa": [21, 3],
  "26ab": [22, 3],
  "1f534": [23, 3],
  "1f535": [24, 3],
  "1f53a": [25, 3],
  "1f53b": [26, 3],
  "1f538": [27, 3],
  "1f539": [28, 3],
  "1f536": [29, 3],
  "1f537": [30, 3],
  "1f533": [31, 3],
  "1f532": [32, 3],
  "25aa-fe0f": [33, 3],
  "25ab-fe0f": [34, 3],
  "25fe": [35, 3],
  "25fd": [36, 3],
  "25fc-fe0f": [37, 3],
  "25fb-fe0f": [38, 3],
  "2b1b": [39, 3],
  "2b1c": [40, 3],
  "1f508": [41, 3],
  "1f507": [42, 3],
  "1f509": [43, 3],
  "1f50a": [44, 3],
  "1f514": [45, 3],
  "1f515": [46, 3],
  "1f4e3": [47, 3],
  "1f4e2": [48, 3],
  "1f5e8-fe0f": [49, 3],
  "1f441-fe0f-200d-1f5e8-fe0f": [50, 3],
  "1f4ac": [51, 3],
  "1f4ad": [52, 3],
  "1f5ef-fe0f": [53, 3],
  "1f0cf": [54, 3],
  "1f3b4": [55, 3],
  "1f004": [56, 3],
  "1f550": [57, 3],
  "1f551": [58, 3],
  "1f552": [59, 3],
  "1f553": [60, 3],
  "1f554": [61, 3],
  "1f555": [62, 3],
  "1f556": [63, 3],
  "1f557": [0, 4],
  "1f558": [1, 4],
  "1f559": [2, 4],
  "1f55a": [3, 4],
  "1f55b": [4, 4],
  "1f55c": [5, 4],
  "1f55d": [6, 4],
  "1f55e": [7, 4],
  "1f55f": [8, 4],
  "1f560": [9, 4],
  "1f561": [10, 4],
  "1f562": [11, 4],
  "1f563": [12, 4],
  "1f564": [13, 4],
  "1f565": [14, 4],
  "1f566": [15, 4],
  "1f567": [16, 4],
  "002a-fe0f": [17, 4],
  "0023-fe0f": [18, 4],
  "0039-fe0f": [19, 4],
  "0038-fe0f": [20, 4],
  "0037-fe0f": [21, 4],
  "0036-fe0f": [22, 4],
  "0035-fe0f": [23, 4],
  "0034-fe0f": [24, 4],
  "0033-fe0f": [25, 4],
  "0032-fe0f": [26, 4],
  "0031-fe0f": [27, 4],
  "0030-fe0f": [28, 4],
  "2328-fe0f": [29, 4],
  "2692-fe0f": [30, 4],
  "2694-fe0f": [31, 4],
  "2696-fe0f": [32, 4],
  "2697-fe0f": [33, 4],
  "2699-fe0f": [34, 4],
  "2702-fe0f": [35, 4],
  "2709-fe0f": [36, 4],
  "2712-fe0f": [37, 4],
  "231a": [38, 4],
  "1f4f1": [39, 4],
  "1f4f2": [40, 4],
  "1f4bb": [41, 4],
  "1f5a5-fe0f": [42, 4],
  "1f5a8-fe0f": [43, 4],
  "1f5b1-fe0f": [44, 4],
  "1f5b2-fe0f": [45, 4],
  "1f579-fe0f": [46, 4],
  "1f5dc-fe0f": [47, 4],
  "1f4bd": [48, 4],
  "1f4be": [49, 4],
  "1f4bf": [50, 4],
  "1f4c0": [51, 4],
  "1f4fc": [52, 4],
  "1f4f7": [53, 4],
  "1f4f8": [54, 4],
  "1f4f9": [55, 4],
  "1f3a5": [56, 4],
  "1f4fd-fe0f": [57, 4],
  "1f39e-fe0f": [58, 4],
  "1f4de": [59, 4],
  "260e-fe0f": [60, 4],
  "1f4df": [61, 4],
  "1f4e0": [62, 4],
  "1f4fa": [63, 4],
  "1f4fb": [0, 5],
  "1f399-fe0f": [1, 5],
  "1f39a-fe0f": [2, 5],
  "1f39b-fe0f": [3, 5],
  "23f1-fe0f": [4, 5],
  "23f2-fe0f": [5, 5],
  "23f0": [6, 5],
  "1f570-fe0f": [7, 5],
  "231b": [8, 5],
  "23f3": [9, 5],
  "1f4e1": [10, 5],
  "1f50b": [11, 5],
  "1f50c": [12, 5],
  "1f4a1": [13, 5],
  "1f526": [14, 5],
  "1f56f-fe0f": [15, 5],
  "1f5d1-fe0f": [16, 5],
  "1f6e2-fe0f": [17, 5],
  "1f4b8": [18, 5],
  "1f4b5": [19, 5],
  "1f4b4": [20, 5],
  "1f4b6": [21, 5],
  "1f4b7": [22, 5],
  "1f4b0": [23, 5],
  "1f4b3": [24, 5],
  "1f48e": [25, 5],
  "1f527": [26, 5],
  "1f528": [27, 5],
  "1f6e0-fe0f": [28, 5],
  "26cf-fe0f": [29, 5],
  "1f529": [30, 5],
  "26d3-fe0f": [31, 5],
  "1f52b": [32, 5],
  "1f4a3": [33, 5],
  "1f52a": [34, 5],
  "1f5e1-fe0f": [35, 5],
  "1f6e1-fe0f": [36, 5],
  "1f6ac": [37, 5],
  "26b0-fe0f": [38, 5],
  "26b1-fe0f": [39, 5],
  "1f3fa": [40, 5],
  "1f52e": [41, 5],
  "1f4ff": [42, 5],
  "1f488": [43, 5],
  "1f52d": [44, 5],
  "1f52c": [45, 5],
  "1f573-fe0f": [46, 5],
  "1f48a": [47, 5],
  "1f489": [48, 5],
  "1f321-fe0f": [49, 5],
  "1f6bd": [50, 5],
  "1f6b0": [51, 5],
  "1f6bf": [52, 5],
  "1f6c1": [53, 5],
  "1f6c0": [54, 5],
  "1f6c0-1f3fb": [55, 5],
  "1f6c0-1f3fc": [56, 5],
  "1f6c0-1f3fd": [57, 5],
  "1f6c0-1f3fe": [58, 5],
  "1f6c0-1f3ff": [59, 5],
  "1f6ce-fe0f": [60, 5],
  "1f511": [61, 5],
  "1f5dd-fe0f": [62, 5],
  "1f6aa": [63, 5],
  "1f6cb-fe0f": [0, 6],
  "1f6cf-fe0f": [1, 6],
  "1f6cc": [2, 6],
  "1f6cc-1f3fb": [3, 6],
  "1f6cc-1f3fc": [4, 6],
  "1f6cc-1f3fd": [5, 6],
  "1f6cc-1f3fe": [6, 6],
  "1f6cc-1f3ff": [7, 6],
  "1f5bc-fe0f": [8, 6],
  "1f6cd-fe0f": [9, 6],
  "1f6d2": [10, 6],
  "1f381": [11, 6],
  "1f388": [12, 6],
  "1f38f": [13, 6],
  "1f380": [14, 6],
  "1f38a": [15, 6],
  "1f389": [16, 6],
  "1f38e": [17, 6],
  "1f3ee": [18, 6],
  "1f390": [19, 6],
  "1f4e9": [20, 6],
  "1f4e8": [21, 6],
  "1f4e7": [22, 6],
  "1f48c": [23, 6],
  "1f4e5": [24, 6],
  "1f4e4": [25, 6],
  "1f4e6": [26, 6],
  "1f3f7-fe0f": [27, 6],
  "1f4ea": [28, 6],
  "1f4eb": [29, 6],
  "1f4ec": [30, 6],
  "1f4ed": [31, 6],
  "1f4ee": [32, 6],
  "1f4ef": [33, 6],
  "1f4dc": [34, 6],
  "1f4c3": [35, 6],
  "1f4c4": [36, 6],
  "1f4d1": [37, 6],
  "1f4ca": [38, 6],
  "1f4c8": [39, 6],
  "1f4c9": [40, 6],
  "1f5d2-fe0f": [41, 6],
  "1f5d3-fe0f": [42, 6],
  "1f4c6": [43, 6],
  "1f4c5": [44, 6],
  "1f4c7": [45, 6],
  "1f5c3-fe0f": [46, 6],
  "1f5f3-fe0f": [47, 6],
  "1f5c4-fe0f": [48, 6],
  "1f4cb": [49, 6],
  "1f4c1": [50, 6],
  "1f4c2": [51, 6],
  "1f5c2-fe0f": [52, 6],
  "1f5de-fe0f": [53, 6],
  "1f4f0": [54, 6],
  "1f4d3": [55, 6],
  "1f4d4": [56, 6],
  "1f4d2": [57, 6],
  "1f4d5": [58, 6],
  "1f4d7": [59, 6],
  "1f4d8": [60, 6],
  "1f4d9": [61, 6],
  "1f4da": [62, 6],
  "1f4d6": [63, 6],
  "1f516": [0, 7],
  "1f517": [1, 7],
  "1f4ce": [2, 7],
  "1f587-fe0f": [3, 7],
  "1f4d0": [4, 7],
  "1f4cf": [5, 7],
  "1f4cc": [6, 7],
  "1f4cd": [7, 7],
  "1f58a-fe0f": [8, 7],
  "1f58b-fe0f": [9, 7],
  "1f58c-fe0f": [10, 7],
  "1f58d-fe0f": [11, 7],
  "1f4dd": [12, 7],
  "270f-fe0f": [13, 7],
  "1f50d": [14, 7],
  "1f50e": [15, 7],
  "1f50f": [16, 7],
  "1f510": [17, 7],
  "1f512": [18, 7],
  "1f513": [19, 7],
  "1f9e1": [20, 7],
  "2600-fe0f": [21, 7],
  "2601-fe0f": [22, 7],
  "2603-fe0f": [23, 7],
  "2604-fe0f": [24, 7],
  "2618-fe0f": [26, 7],
  "2744-fe0f": [28, 7],
  "1f436": [29, 7],
  "1f431": [30, 7],
  "1f42d": [31, 7],
  "1f439": [32, 7],
  "1f430": [33, 7],
  "1f98a": [34, 7],
  "1f43b": [35, 7],
  "1f43c": [36, 7],
  "1f428": [37, 7],
  "1f42f": [38, 7],
  "1f981": [39, 7],
  "1f42e": [40, 7],
  "1f437": [41, 7],
  "1f43d": [42, 7],
  "1f438": [43, 7],
  "1f435": [44, 7],
  "1f648": [45, 7],
  "1f649": [46, 7],
  "1f64a": [47, 7],
  "1f412": [48, 7],
  "1f414": [49, 7],
  "1f427": [50, 7],
  "1f426": [51, 7],
  "1f424": [52, 7],
  "1f423": [53, 7],
  "1f425": [54, 7],
  "1f986": [55, 7],
  "1f985": [56, 7],
  "1f989": [57, 7],
  "1f987": [58, 7],
  "1f43a": [59, 7],
  "1f417": [60, 7],
  "1f434": [61, 7],
  "1f984": [62, 7],
  "1f41d": [63, 7],
  "1f41b": [0, 8],
  "1f98b": [1, 8],
  "1f40c": [2, 8],
  "1f41a": [3, 8],
  "1f41e": [4, 8],
  "1f41c": [5, 8],
  "1f577-fe0f": [6, 8],
  "1f578-fe0f": [7, 8],
  "1f422": [8, 8],
  "1f40d": [9, 8],
  "1f98e": [10, 8],
  "1f982": [11, 8],
  "1f980": [12, 8],
  "1f991": [13, 8],
  "1f419": [14, 8],
  "1f990": [15, 8],
  "1f420": [16, 8],
  "1f41f": [17, 8],
  "1f421": [18, 8],
  "1f42c": [19, 8],
  "1f988": [20, 8],
  "1f433": [21, 8],
  "1f40b": [22, 8],
  "1f40a": [23, 8],
  "1f406": [24, 8],
  "1f405": [25, 8],
  "1f403": [26, 8],
  "1f402": [27, 8],
  "1f404": [28, 8],
  "1f98c": [29, 8],
  "1f42a": [30, 8],
  "1f42b": [31, 8],
  "1f418": [32, 8],
  "1f98f": [33, 8],
  "1f98d": [34, 8],
  "1f40e": [35, 8],
  "1f416": [36, 8],
  "1f410": [37, 8],
  "1f40f": [38, 8],
  "1f411": [39, 8],
  "1f415": [40, 8],
  "1f429": [41, 8],
  "1f408": [42, 8],
  "1f413": [43, 8],
  "1f983": [44, 8],
  "1f54a-fe0f": [45, 8],
  "1f407": [46, 8],
  "1f401": [47, 8],
  "1f400": [48, 8],
  "1f43f-fe0f": [49, 8],
  "1f43e": [50, 8],
  "1f409": [51, 8],
  "1f432": [52, 8],
  "1f335": [53, 8],
  "1f384": [54, 8],
  "1f332": [55, 8],
  "1f333": [56, 8],
  "1f334": [57, 8],
  "1f331": [58, 8],
  "1f33f": [59, 8],
  "1f340": [60, 8],
  "1f38d": [61, 8],
  "1f38b": [62, 8],
  "1f343": [63, 8],
  "1f342": [0, 9],
  "1f341": [1, 9],
  "1f344": [2, 9],
  "1f33e": [3, 9],
  "1f490": [4, 9],
  "1f337": [5, 9],
  "1f339": [6, 9],
  "1f940": [7, 9],
  "1f33b": [8, 9],
  "1f33c": [9, 9],
  "1f338": [10, 9],
  "1f33a": [11, 9],
  "1f30e": [12, 9],
  "1f30d": [13, 9],
  "1f30f": [14, 9],
  "1f315": [15, 9],
  "1f316": [16, 9],
  "1f317": [17, 9],
  "1f318": [18, 9],
  "1f311": [19, 9],
  "1f312": [20, 9],
  "1f313": [21, 9],
  "1f314": [22, 9],
  "1f31a": [23, 9],
  "1f31d": [24, 9],
  "1f31e": [25, 9],
  "1f31b": [26, 9],
  "1f31c": [27, 9],
  "1f319": [28, 9],
  "1f4ab": [29, 9],
  "2b50": [30, 9],
  "1f31f": [31, 9],
  "26a1": [32, 9],
  "1f525": [33, 9],
  "1f4a5": [34, 9],
  "1f324-fe0f": [35, 9],
  "26c5": [36, 9],
  "1f325-fe0f": [37, 9],
  "1f326-fe0f": [38, 9],
  "1f308": [39, 9],
  "1f327-fe0f": [40, 9],
  "26c8-fe0f": [41, 9],
  "1f329-fe0f": [42, 9],
  "1f328-fe0f": [43, 9],
  "26c4": [44, 9],
  "1f32c-fe0f": [45, 9],
  "1f4a8": [46, 9],
  "1f32a-fe0f": [47, 9],
  "1f32b-fe0f": [48, 9],
  "1f30a": [49, 9],
  "1f4a7": [50, 9],
  "1f4a6": [51, 9],
  "1f992": [52, 9],
  "1f993": [53, 9],
  "1f994": [54, 9],
  "1f995": [55, 9],
  "1f996": [56, 9],
  "1f997": [57, 9],
  "2602-fe0f": [58, 9],
  "2620-fe0f": [59, 9],
  "2639-fe0f": [60, 9],
  "2640-fe0f": [61, 9],
  "2642-fe0f": [62, 9],
  "2695-fe0f": [63, 9],
  "1f600": [0, 10],
  "1f603": [1, 10],
  "1f604": [2, 10],
  "1f601": [3, 10],
  "1f606": [4, 10],
  "1f605": [5, 10],
  "1f602": [6, 10],
  "1f923": [7, 10],
  "263a-fe0f": [8, 10],
  "1f60a": [9, 10],
  "1f607": [10, 10],
  "1f642": [11, 10],
  "1f643": [12, 10],
  "1f609": [13, 10],
  "1f60c": [14, 10],
  "1f60d": [15, 10],
  "1f618": [16, 10],
  "1f617": [17, 10],
  "1f619": [18, 10],
  "1f61a": [19, 10],
  "1f60b": [20, 10],
  "1f61c": [21, 10],
  "1f61d": [22, 10],
  "1f61b": [23, 10],
  "1f911": [24, 10],
  "1f917": [25, 10],
  "1f913": [26, 10],
  "1f60e": [27, 10],
  "1f921": [28, 10],
  "1f920": [29, 10],
  "1f60f": [30, 10],
  "1f612": [31, 10],
  "1f61e": [32, 10],
  "1f614": [33, 10],
  "1f61f": [34, 10],
  "1f615": [35, 10],
  "1f641": [36, 10],
  "1f623": [37, 10],
  "1f616": [38, 10],
  "1f62b": [39, 10],
  "1f629": [40, 10],
  "1f624": [41, 10],
  "1f620": [42, 10],
  "1f621": [43, 10],
  "1f636": [44, 10],
  "1f610": [45, 10],
  "1f611": [46, 10],
  "1f62f": [47, 10],
  "1f626": [48, 10],
  "1f627": [49, 10],
  "1f62e": [50, 10],
  "1f632": [51, 10],
  "1f635": [52, 10],
  "1f633": [53, 10],
  "1f631": [54, 10],
  "1f628": [55, 10],
  "1f630": [56, 10],
  "1f622": [57, 10],
  "1f625": [58, 10],
  "1f924": [59, 10],
  "1f62d": [60, 10],
  "1f613": [61, 10],
  "1f62a": [62, 10],
  "1f634": [63, 10],
  "1f644": [0, 11],
  "1f914": [1, 11],
  "1f925": [2, 11],
  "1f62c": [3, 11],
  "1f910": [4, 11],
  "1f922": [5, 11],
  "1f927": [6, 11],
  "1f637": [7, 11],
  "1f912": [8, 11],
  "1f915": [9, 11],
  "1f608": [10, 11],
  "1f47f": [11, 11],
  "1f479": [12, 11],
  "1f47a": [13, 11],
  "1f4a9": [14, 11],
  "1f47b": [15, 11],
  "1f480": [16, 11],
  "1f47d": [17, 11],
  "1f47e": [18, 11],
  "1f916": [19, 11],
  "1f383": [20, 11],
  "1f63a": [21, 11],
  "1f638": [22, 11],
  "1f639": [23, 11],
  "1f63b": [24, 11],
  "1f63c": [25, 11],
  "1f63d": [26, 11],
  "1f640": [27, 11],
  "1f63f": [28, 11],
  "1f63e": [29, 11],
  "1f450": [30, 11],
  "1f450-1f3fb": [31, 11],
  "1f450-1f3fc": [32, 11],
  "1f450-1f3fd": [33, 11],
  "1f450-1f3fe": [34, 11],
  "1f450-1f3ff": [35, 11],
  "1f64c": [36, 11],
  "1f64c-1f3fb": [37, 11],
  "1f64c-1f3fc": [38, 11],
  "1f64c-1f3fd": [39, 11],
  "1f64c-1f3fe": [40, 11],
  "1f64c-1f3ff": [41, 11],
  "1f44f": [42, 11],
  "1f44f-1f3fb": [43, 11],
  "1f44f-1f3fc": [44, 11],
  "1f44f-1f3fd": [45, 11],
  "1f44f-1f3fe": [46, 11],
  "1f44f-1f3ff": [47, 11],
  "1f64f": [48, 11],
  "1f64f-1f3fb": [49, 11],
  "1f64f-1f3fc": [50, 11],
  "1f64f-1f3fd": [51, 11],
  "1f64f-1f3fe": [52, 11],
  "1f64f-1f3ff": [53, 11],
  "1f91d": [54, 11],
  "1f44d": [55, 11],
  "1f44d-1f3fb": [56, 11],
  "1f44d-1f3fc": [57, 11],
  "1f44d-1f3fd": [58, 11],
  "1f44d-1f3fe": [59, 11],
  "1f44d-1f3ff": [60, 11],
  "1f44e": [61, 11],
  "1f44e-1f3fb": [62, 11],
  "1f44e-1f3fc": [63, 11],
  "1f44e-1f3fd": [0, 12],
  "1f44e-1f3fe": [1, 12],
  "1f44e-1f3ff": [2, 12],
  "1f44a": [3, 12],
  "1f44a-1f3fb": [4, 12],
  "1f44a-1f3fc": [5, 12],
  "1f44a-1f3fd": [6, 12],
  "1f44a-1f3fe": [7, 12],
  "1f44a-1f3ff": [8, 12],
  "270a": [9, 12],
  "270a-1f3fb": [10, 12],
  "270a-1f3fc": [11, 12],
  "270a-1f3fd": [12, 12],
  "270a-1f3fe": [13, 12],
  "270a-1f3ff": [14, 12],
  "1f91b": [15, 12],
  "1f91b-1f3fb": [16, 12],
  "1f91b-1f3fc": [17, 12],
  "1f91b-1f3fd": [18, 12],
  "1f91b-1f3fe": [19, 12],
  "1f91b-1f3ff": [20, 12],
  "1f91c": [21, 12],
  "1f91c-1f3fb": [22, 12],
  "1f91c-1f3fc": [23, 12],
  "1f91c-1f3fd": [24, 12],
  "1f91c-1f3fe": [25, 12],
  "1f91c-1f3ff": [26, 12],
  "1f91e": [27, 12],
  "1f91e-1f3fb": [28, 12],
  "1f91e-1f3fc": [29, 12],
  "1f91e-1f3fd": [30, 12],
  "1f91e-1f3fe": [31, 12],
  "1f91e-1f3ff": [32, 12],
  "270c-fe0f": [33, 12],
  "270c-1f3fb": [34, 12],
  "270c-1f3fc": [35, 12],
  "270c-1f3fd": [36, 12],
  "270c-1f3fe": [37, 12],
  "270c-1f3ff": [38, 12],
  "1f918": [39, 12],
  "1f918-1f3fb": [40, 12],
  "1f918-1f3fc": [41, 12],
  "1f918-1f3fd": [42, 12],
  "1f918-1f3fe": [43, 12],
  "1f918-1f3ff": [44, 12],
  "1f44c": [45, 12],
  "1f44c-1f3fb": [46, 12],
  "1f44c-1f3fc": [47, 12],
  "1f44c-1f3fd": [48, 12],
  "1f44c-1f3fe": [49, 12],
  "1f44c-1f3ff": [50, 12],
  "1f448": [51, 12],
  "1f448-1f3fb": [52, 12],
  "1f448-1f3fc": [53, 12],
  "1f448-1f3fd": [54, 12],
  "1f448-1f3fe": [55, 12],
  "1f448-1f3ff": [56, 12],
  "1f449": [57, 12],
  "1f449-1f3fb": [58, 12],
  "1f449-1f3fc": [59, 12],
  "1f449-1f3fd": [60, 12],
  "1f449-1f3fe": [61, 12],
  "1f449-1f3ff": [62, 12],
  "1f446": [63, 12],
  "1f446-1f3fb": [0, 13],
  "1f446-1f3fc": [1, 13],
  "1f446-1f3fd": [2, 13],
  "1f446-1f3fe": [3, 13],
  "1f446-1f3ff": [4, 13],
  "1f447": [5, 13],
  "1f447-1f3fb": [6, 13],
  "1f447-1f3fc": [7, 13],
  "1f447-1f3fd": [8, 13],
  "1f447-1f3fe": [9, 13],
  "1f447-1f3ff": [10, 13],
  "261d-fe0f": [11, 13],
  "261d-1f3fb": [12, 13],
  "261d-1f3fc": [13, 13],
  "261d-1f3fd": [14, 13],
  "261d-1f3fe": [15, 13],
  "261d-1f3ff": [16, 13],
  "270b": [17, 13],
  "270b-1f3fb": [18, 13],
  "270b-1f3fc": [19, 13],
  "270b-1f3fd": [20, 13],
  "270b-1f3fe": [21, 13],
  "270b-1f3ff": [22, 13],
  "1f91a": [23, 13],
  "1f91a-1f3fb": [24, 13],
  "1f91a-1f3fc": [25, 13],
  "1f91a-1f3fd": [26, 13],
  "1f91a-1f3fe": [27, 13],
  "1f91a-1f3ff": [28, 13],
  "1f590-fe0f": [29, 13],
  "1f590-1f3fb": [30, 13],
  "1f590-1f3fc": [31, 13],
  "1f590-1f3fd": [32, 13],
  "1f590-1f3fe": [33, 13],
  "1f590-1f3ff": [34, 13],
  "1f596": [35, 13],
  "1f596-1f3fb": [36, 13],
  "1f596-1f3fc": [37, 13],
  "1f596-1f3fd": [38, 13],
  "1f596-1f3fe": [39, 13],
  "1f596-1f3ff": [40, 13],
  "1f44b": [41, 13],
  "1f44b-1f3fb": [42, 13],
  "1f44b-1f3fc": [43, 13],
  "1f44b-1f3fd": [44, 13],
  "1f44b-1f3fe": [45, 13],
  "1f44b-1f3ff": [46, 13],
  "1f919": [47, 13],
  "1f919-1f3fb": [48, 13],
  "1f919-1f3fc": [49, 13],
  "1f919-1f3fd": [50, 13],
  "1f919-1f3fe": [51, 13],
  "1f919-1f3ff": [52, 13],
  "1f4aa": [53, 13],
  "1f4aa-1f3fb": [54, 13],
  "1f4aa-1f3fc": [55, 13],
  "1f4aa-1f3fd": [56, 13],
  "1f4aa-1f3fe": [57, 13],
  "1f4aa-1f3ff": [58, 13],
  "1f595": [59, 13],
  "1f595-1f3fb": [60, 13],
  "1f595-1f3fc": [61, 13],
  "1f595-1f3fd": [62, 13],
  "1f595-1f3fe": [63, 13],
  "1f595-1f3ff": [0, 14],
  "270d-fe0f": [1, 14],
  "270d-1f3fb": [2, 14],
  "270d-1f3fc": [3, 14],
  "270d-1f3fd": [4, 14],
  "270d-1f3fe": [5, 14],
  "270d-1f3ff": [6, 14],
  "1f933": [7, 14],
  "1f933-1f3fb": [8, 14],
  "1f933-1f3fc": [9, 14],
  "1f933-1f3fd": [10, 14],
  "1f933-1f3fe": [11, 14],
  "1f933-1f3ff": [12, 14],
  "1f485": [13, 14],
  "1f485-1f3fb": [14, 14],
  "1f485-1f3fc": [15, 14],
  "1f485-1f3fd": [16, 14],
  "1f485-1f3fe": [17, 14],
  "1f485-1f3ff": [18, 14],
  "1f48d": [19, 14],
  "1f484": [20, 14],
  "1f48b": [21, 14],
  "1f444": [22, 14],
  "1f445": [23, 14],
  "1f442": [24, 14],
  "1f442-1f3fb": [25, 14],
  "1f442-1f3fc": [26, 14],
  "1f442-1f3fd": [27, 14],
  "1f442-1f3fe": [28, 14],
  "1f442-1f3ff": [29, 14],
  "1f443": [30, 14],
  "1f443-1f3fb": [31, 14],
  "1f443-1f3fc": [32, 14],
  "1f443-1f3fd": [33, 14],
  "1f443-1f3fe": [34, 14],
  "1f443-1f3ff": [35, 14],
  "1f463": [36, 14],
  "1f441-fe0f": [37, 14],
  "1f440": [38, 14],
  "1f5e3-fe0f": [39, 14],
  "1f464": [40, 14],
  "1f465": [41, 14],
  "1f476": [42, 14],
  "1f476-1f3fb": [43, 14],
  "1f476-1f3fc": [44, 14],
  "1f476-1f3fd": [45, 14],
  "1f476-1f3fe": [46, 14],
  "1f476-1f3ff": [47, 14],
  "1f466": [48, 14],
  "1f466-1f3fb": [49, 14],
  "1f466-1f3fc": [50, 14],
  "1f466-1f3fd": [51, 14],
  "1f466-1f3fe": [52, 14],
  "1f466-1f3ff": [53, 14],
  "1f467": [54, 14],
  "1f467-1f3fb": [55, 14],
  "1f467-1f3fc": [56, 14],
  "1f467-1f3fd": [57, 14],
  "1f467-1f3fe": [58, 14],
  "1f467-1f3ff": [59, 14],
  "1f468": [60, 14],
  "1f468-1f3fb": [61, 14],
  "1f468-1f3fc": [62, 14],
  "1f468-1f3fd": [63, 14],
  "1f468-1f3fe": [0, 15],
  "1f468-1f3ff": [1, 15],
  "1f469": [2, 15],
  "1f469-1f3fb": [3, 15],
  "1f469-1f3fc": [4, 15],
  "1f469-1f3fd": [5, 15],
  "1f469-1f3fe": [6, 15],
  "1f469-1f3ff": [7, 15],
  "1f471-200d-2640-fe0f": [8, 15],
  "1f471-1f3fb-200d-2640-fe0f": [9, 15],
  "1f471-1f3fc-200d-2640-fe0f": [10, 15],
  "1f471-1f3fd-200d-2640-fe0f": [11, 15],
  "1f471-1f3fe-200d-2640-fe0f": [12, 15],
  "1f471-1f3ff-200d-2640-fe0f": [13, 15],
  "1f471": [14, 15],
  "1f471-1f3fb": [15, 15],
  "1f471-1f3fc": [16, 15],
  "1f471-1f3fd": [17, 15],
  "1f471-1f3fe": [18, 15],
  "1f471-1f3ff": [19, 15],
  "1f471-200d-2642-fe0f": [20, 15],
  "1f471-1f3ff-200d-2642-fe0f": [21, 15],
  "1f471-1f3fe-200d-2642-fe0f": [22, 15],
  "1f471-1f3fd-200d-2642-fe0f": [23, 15],
  "1f471-1f3fc-200d-2642-fe0f": [24, 15],
  "1f471-1f3fb-200d-2642-fe0f": [25, 15],
  "1f474": [26, 15],
  "1f474-1f3fb": [27, 15],
  "1f474-1f3fc": [28, 15],
  "1f474-1f3fd": [29, 15],
  "1f474-1f3fe": [30, 15],
  "1f474-1f3ff": [31, 15],
  "1f475": [32, 15],
  "1f475-1f3fb": [33, 15],
  "1f475-1f3fc": [34, 15],
  "1f475-1f3fd": [35, 15],
  "1f475-1f3fe": [36, 15],
  "1f475-1f3ff": [37, 15],
  "1f472": [38, 15],
  "1f472-1f3fb": [39, 15],
  "1f472-1f3fc": [40, 15],
  "1f472-1f3fd": [41, 15],
  "1f472-1f3fe": [42, 15],
  "1f472-1f3ff": [43, 15],
  "1f473-200d-2640-fe0f": [44, 15],
  "1f473-1f3fb-200d-2640-fe0f": [45, 15],
  "1f473-1f3fc-200d-2640-fe0f": [46, 15],
  "1f473-1f3fd-200d-2640-fe0f": [47, 15],
  "1f473-1f3fe-200d-2640-fe0f": [48, 15],
  "1f473-1f3ff-200d-2640-fe0f": [49, 15],
  "1f473": [50, 15],
  "1f473-1f3fb": [51, 15],
  "1f473-1f3fc": [52, 15],
  "1f473-1f3fd": [53, 15],
  "1f473-1f3fe": [54, 15],
  "1f473-1f3ff": [55, 15],
  "1f473-200d-2642-fe0f": [56, 15],
  "1f473-1f3ff-200d-2642-fe0f": [57, 15],
  "1f473-1f3fe-200d-2642-fe0f": [58, 15],
  "1f473-1f3fd-200d-2642-fe0f": [59, 15],
  "1f473-1f3fc-200d-2642-fe0f": [60, 15],
  "1f473-1f3fb-200d-2642-fe0f": [61, 15],
  "1f46e-200d-2640-fe0f": [62, 15],
  "1f46e-1f3fb-200d-2640-fe0f": [63, 15],
  "1f46e-1f3fc-200d-2640-fe0f": [0, 16],
  "1f46e-1f3fd-200d-2640-fe0f": [1, 16],
  "1f46e-1f3fe-200d-2640-fe0f": [2, 16],
  "1f46e-1f3ff-200d-2640-fe0f": [3, 16],
  "1f46e": [4, 16],
  "1f46e-1f3fb": [5, 16],
  "1f46e-1f3fc": [6, 16],
  "1f46e-1f3fd": [7, 16],
  "1f46e-1f3fe": [8, 16],
  "1f46e-1f3ff": [9, 16],
  "1f46e-200d-2642-fe0f": [10, 16],
  "1f46e-1f3ff-200d-2642-fe0f": [11, 16],
  "1f46e-1f3fe-200d-2642-fe0f": [12, 16],
  "1f46e-1f3fd-200d-2642-fe0f": [13, 16],
  "1f46e-1f3fc-200d-2642-fe0f": [14, 16],
  "1f46e-1f3fb-200d-2642-fe0f": [15, 16],
  "1f477-200d-2640-fe0f": [16, 16],
  "1f477-1f3fb-200d-2640-fe0f": [17, 16],
  "1f477-1f3fc-200d-2640-fe0f": [18, 16],
  "1f477-1f3fd-200d-2640-fe0f": [19, 16],
  "1f477-1f3fe-200d-2640-fe0f": [20, 16],
  "1f477-1f3ff-200d-2640-fe0f": [21, 16],
  "1f477": [22, 16],
  "1f477-1f3fb": [23, 16],
  "1f477-1f3fc": [24, 16],
  "1f477-1f3fd": [25, 16],
  "1f477-1f3fe": [26, 16],
  "1f477-1f3ff": [27, 16],
  "1f477-200d-2642-fe0f": [28, 16],
  "1f477-1f3ff-200d-2642-fe0f": [29, 16],
  "1f477-1f3fe-200d-2642-fe0f": [30, 16],
  "1f477-1f3fd-200d-2642-fe0f": [31, 16],
  "1f477-1f3fc-200d-2642-fe0f": [32, 16],
  "1f477-1f3fb-200d-2642-fe0f": [33, 16],
  "1f482-200d-2640-fe0f": [34, 16],
  "1f482-1f3fb-200d-2640-fe0f": [35, 16],
  "1f482-1f3fc-200d-2640-fe0f": [36, 16],
  "1f482-1f3fd-200d-2640-fe0f": [37, 16],
  "1f482-1f3fe-200d-2640-fe0f": [38, 16],
  "1f482-1f3ff-200d-2640-fe0f": [39, 16],
  "1f482": [40, 16],
  "1f482-1f3fb": [41, 16],
  "1f482-1f3fc": [42, 16],
  "1f482-1f3fd": [43, 16],
  "1f482-1f3fe": [44, 16],
  "1f482-1f3ff": [45, 16],
  "1f482-200d-2642-fe0f": [46, 16],
  "1f482-1f3ff-200d-2642-fe0f": [47, 16],
  "1f482-1f3fe-200d-2642-fe0f": [48, 16],
  "1f482-1f3fd-200d-2642-fe0f": [49, 16],
  "1f482-1f3fc-200d-2642-fe0f": [50, 16],
  "1f482-1f3fb-200d-2642-fe0f": [51, 16],
  "1f575-fe0f-200d-2640-fe0f": [52, 16],
  "1f575-1f3fb-200d-2640-fe0f": [53, 16],
  "1f575-1f3fc-200d-2640-fe0f": [54, 16],
  "1f575-1f3fd-200d-2640-fe0f": [55, 16],
  "1f575-1f3fe-200d-2640-fe0f": [56, 16],
  "1f575-1f3ff-200d-2640-fe0f": [57, 16],
  "1f575-fe0f": [58, 16],
  "1f575-1f3fb": [59, 16],
  "1f575-1f3fc": [60, 16],
  "1f575-1f3fd": [61, 16],
  "1f575-1f3fe": [62, 16],
  "1f575-1f3ff": [63, 16],
  "1f575-fe0f-200d-2642-fe0f": [0, 17],
  "1f575-1f3ff-200d-2642-fe0f": [1, 17],
  "1f575-1f3fe-200d-2642-fe0f": [2, 17],
  "1f575-1f3fd-200d-2642-fe0f": [3, 17],
  "1f575-1f3fc-200d-2642-fe0f": [4, 17],
  "1f575-1f3fb-200d-2642-fe0f": [5, 17],
  "1f469-200d-2695-fe0f": [6, 17],
  "1f469-1f3fb-200d-2695-fe0f": [7, 17],
  "1f469-1f3fc-200d-2695-fe0f": [8, 17],
  "1f469-1f3fd-200d-2695-fe0f": [9, 17],
  "1f469-1f3fe-200d-2695-fe0f": [10, 17],
  "1f469-1f3ff-200d-2695-fe0f": [11, 17],
  "1f468-200d-2695-fe0f": [12, 17],
  "1f468-1f3fb-200d-2695-fe0f": [13, 17],
  "1f468-1f3fc-200d-2695-fe0f": [14, 17],
  "1f468-1f3fd-200d-2695-fe0f": [15, 17],
  "1f468-1f3fe-200d-2695-fe0f": [16, 17],
  "1f468-1f3ff-200d-2695-fe0f": [17, 17],
  "1f469-200d-1f33e": [18, 17],
  "1f469-1f3fb-200d-1f33e": [19, 17],
  "1f469-1f3fc-200d-1f33e": [20, 17],
  "1f469-1f3fd-200d-1f33e": [21, 17],
  "1f469-1f3fe-200d-1f33e": [22, 17],
  "1f469-1f3ff-200d-1f33e": [23, 17],
  "1f468-200d-1f33e": [24, 17],
  "1f468-1f3fb-200d-1f33e": [25, 17],
  "1f468-1f3fc-200d-1f33e": [26, 17],
  "1f468-1f3fd-200d-1f33e": [27, 17],
  "1f468-1f3fe-200d-1f33e": [28, 17],
  "1f468-1f3ff-200d-1f33e": [29, 17],
  "1f469-200d-1f373": [30, 17],
  "1f469-1f3fb-200d-1f373": [31, 17],
  "1f469-1f3fc-200d-1f373": [32, 17],
  "1f469-1f3fd-200d-1f373": [33, 17],
  "1f469-1f3fe-200d-1f373": [34, 17],
  "1f469-1f3ff-200d-1f373": [35, 17],
  "1f468-200d-1f373": [36, 17],
  "1f468-1f3fb-200d-1f373": [37, 17],
  "1f468-1f3fc-200d-1f373": [38, 17],
  "1f468-1f3fd-200d-1f373": [39, 17],
  "1f468-1f3fe-200d-1f373": [40, 17],
  "1f468-1f3ff-200d-1f373": [41, 17],
  "1f469-200d-1f393": [42, 17],
  "1f469-1f3fb-200d-1f393": [43, 17],
  "1f469-1f3fc-200d-1f393": [44, 17],
  "1f469-1f3fd-200d-1f393": [45, 17],
  "1f469-1f3fe-200d-1f393": [46, 17],
  "1f469-1f3ff-200d-1f393": [47, 17],
  "1f468-200d-1f393": [48, 17],
  "1f468-1f3fb-200d-1f393": [49, 17],
  "1f468-1f3fc-200d-1f393": [50, 17],
  "1f468-1f3fd-200d-1f393": [51, 17],
  "1f468-1f3fe-200d-1f393": [52, 17],
  "1f468-1f3ff-200d-1f393": [53, 17],
  "1f469-200d-1f3a4": [54, 17],
  "1f469-1f3fb-200d-1f3a4": [55, 17],
  "1f469-1f3fc-200d-1f3a4": [56, 17],
  "1f469-1f3fd-200d-1f3a4": [57, 17],
  "1f469-1f3fe-200d-1f3a4": [58, 17],
  "1f469-1f3ff-200d-1f3a4": [59, 17],
  "1f468-200d-1f3a4": [60, 17],
  "1f468-1f3fb-200d-1f3a4": [61, 17],
  "1f468-1f3fc-200d-1f3a4": [62, 17],
  "1f468-1f3fd-200d-1f3a4": [63, 17],
  "1f468-1f3fe-200d-1f3a4": [0, 18],
  "1f468-1f3ff-200d-1f3a4": [1, 18],
  "1f469-200d-1f3eb": [2, 18],
  "1f469-1f3fb-200d-1f3eb": [3, 18],
  "1f469-1f3fc-200d-1f3eb": [4, 18],
  "1f469-1f3fd-200d-1f3eb": [5, 18],
  "1f469-1f3fe-200d-1f3eb": [6, 18],
  "1f469-1f3ff-200d-1f3eb": [7, 18],
  "1f468-200d-1f3eb": [8, 18],
  "1f468-1f3fb-200d-1f3eb": [9, 18],
  "1f468-1f3fc-200d-1f3eb": [10, 18],
  "1f468-1f3fd-200d-1f3eb": [11, 18],
  "1f468-1f3fe-200d-1f3eb": [12, 18],
  "1f468-1f3ff-200d-1f3eb": [13, 18],
  "1f469-200d-1f3ed": [14, 18],
  "1f469-1f3fb-200d-1f3ed": [15, 18],
  "1f469-1f3fc-200d-1f3ed": [16, 18],
  "1f469-1f3fd-200d-1f3ed": [17, 18],
  "1f469-1f3fe-200d-1f3ed": [18, 18],
  "1f469-1f3ff-200d-1f3ed": [19, 18],
  "1f468-200d-1f3ed": [20, 18],
  "1f468-1f3fb-200d-1f3ed": [21, 18],
  "1f468-1f3fc-200d-1f3ed": [22, 18],
  "1f468-1f3fd-200d-1f3ed": [23, 18],
  "1f468-1f3fe-200d-1f3ed": [24, 18],
  "1f468-1f3ff-200d-1f3ed": [25, 18],
  "1f469-200d-1f4bb": [26, 18],
  "1f469-1f3fb-200d-1f4bb": [27, 18],
  "1f469-1f3fc-200d-1f4bb": [28, 18],
  "1f469-1f3fd-200d-1f4bb": [29, 18],
  "1f469-1f3fe-200d-1f4bb": [30, 18],
  "1f469-1f3ff-200d-1f4bb": [31, 18],
  "1f468-200d-1f4bb": [32, 18],
  "1f468-1f3fb-200d-1f4bb": [33, 18],
  "1f468-1f3fc-200d-1f4bb": [34, 18],
  "1f468-1f3fd-200d-1f4bb": [35, 18],
  "1f468-1f3fe-200d-1f4bb": [36, 18],
  "1f468-1f3ff-200d-1f4bb": [37, 18],
  "1f469-200d-1f4bc": [38, 18],
  "1f469-1f3fb-200d-1f4bc": [39, 18],
  "1f469-1f3fc-200d-1f4bc": [40, 18],
  "1f469-1f3fd-200d-1f4bc": [41, 18],
  "1f469-1f3fe-200d-1f4bc": [42, 18],
  "1f469-1f3ff-200d-1f4bc": [43, 18],
  "1f468-200d-1f4bc": [44, 18],
  "1f468-1f3fb-200d-1f4bc": [45, 18],
  "1f468-1f3fc-200d-1f4bc": [46, 18],
  "1f468-1f3fd-200d-1f4bc": [47, 18],
  "1f468-1f3fe-200d-1f4bc": [48, 18],
  "1f468-1f3ff-200d-1f4bc": [49, 18],
  "1f469-200d-1f527": [50, 18],
  "1f469-1f3fb-200d-1f527": [51, 18],
  "1f469-1f3fc-200d-1f527": [52, 18],
  "1f469-1f3fd-200d-1f527": [53, 18],
  "1f469-1f3fe-200d-1f527": [54, 18],
  "1f469-1f3ff-200d-1f527": [55, 18],
  "1f468-200d-1f527": [56, 18],
  "1f468-1f3fb-200d-1f527": [57, 18],
  "1f468-1f3fc-200d-1f527": [58, 18],
  "1f468-1f3fd-200d-1f527": [59, 18],
  "1f468-1f3fe-200d-1f527": [60, 18],
  "1f468-1f3ff-200d-1f527": [61, 18],
  "1f469-200d-1f52c": [62, 18],
  "1f469-1f3fb-200d-1f52c": [63, 18],
  "1f469-1f3fc-200d-1f52c": [0, 19],
  "1f469-1f3fd-200d-1f52c": [1, 19],
  "1f469-1f3fe-200d-1f52c": [2, 19],
  "1f469-1f3ff-200d-1f52c": [3, 19],
  "1f468-200d-1f52c": [4, 19],
  "1f468-1f3fb-200d-1f52c": [5, 19],
  "1f468-1f3fc-200d-1f52c": [6, 19],
  "1f468-1f3fd-200d-1f52c": [7, 19],
  "1f468-1f3fe-200d-1f52c": [8, 19],
  "1f468-1f3ff-200d-1f52c": [9, 19],
  "1f469-200d-1f3a8": [10, 19],
  "1f469-1f3fb-200d-1f3a8": [11, 19],
  "1f469-1f3fc-200d-1f3a8": [12, 19],
  "1f469-1f3fd-200d-1f3a8": [13, 19],
  "1f469-1f3fe-200d-1f3a8": [14, 19],
  "1f469-1f3ff-200d-1f3a8": [15, 19],
  "1f468-200d-1f3a8": [16, 19],
  "1f468-1f3fb-200d-1f3a8": [17, 19],
  "1f468-1f3fc-200d-1f3a8": [18, 19],
  "1f468-1f3fd-200d-1f3a8": [19, 19],
  "1f468-1f3fe-200d-1f3a8": [20, 19],
  "1f468-1f3ff-200d-1f3a8": [21, 19],
  "1f469-200d-1f692": [22, 19],
  "1f469-1f3fb-200d-1f692": [23, 19],
  "1f469-1f3fc-200d-1f692": [24, 19],
  "1f469-1f3fd-200d-1f692": [25, 19],
  "1f469-1f3fe-200d-1f692": [26, 19],
  "1f469-1f3ff-200d-1f692": [27, 19],
  "1f468-200d-1f692": [28, 19],
  "1f468-1f3fb-200d-1f692": [29, 19],
  "1f468-1f3fc-200d-1f692": [30, 19],
  "1f468-1f3fd-200d-1f692": [31, 19],
  "1f468-1f3fe-200d-1f692": [32, 19],
  "1f468-1f3ff-200d-1f692": [33, 19],
  "1f469-200d-2708-fe0f": [34, 19],
  "1f469-1f3fb-200d-2708-fe0f": [35, 19],
  "1f469-1f3fc-200d-2708-fe0f": [36, 19],
  "1f469-1f3fd-200d-2708-fe0f": [37, 19],
  "1f469-1f3fe-200d-2708-fe0f": [38, 19],
  "1f469-1f3ff-200d-2708-fe0f": [39, 19],
  "1f468-200d-2708-fe0f": [40, 19],
  "1f468-1f3fb-200d-2708-fe0f": [41, 19],
  "1f468-1f3fc-200d-2708-fe0f": [42, 19],
  "1f468-1f3fd-200d-2708-fe0f": [43, 19],
  "1f468-1f3fe-200d-2708-fe0f": [44, 19],
  "1f468-1f3ff-200d-2708-fe0f": [45, 19],
  "1f469-200d-1f680": [46, 19],
  "1f469-1f3fb-200d-1f680": [47, 19],
  "1f469-1f3fc-200d-1f680": [48, 19],
  "1f469-1f3fd-200d-1f680": [49, 19],
  "1f469-1f3fe-200d-1f680": [50, 19],
  "1f469-1f3ff-200d-1f680": [51, 19],
  "1f468-200d-1f680": [52, 19],
  "1f468-1f3fb-200d-1f680": [53, 19],
  "1f468-1f3fc-200d-1f680": [54, 19],
  "1f468-1f3fd-200d-1f680": [55, 19],
  "1f468-1f3fe-200d-1f680": [56, 19],
  "1f468-1f3ff-200d-1f680": [57, 19],
  "1f469-200d-2696-fe0f": [58, 19],
  "1f469-1f3fb-200d-2696-fe0f": [59, 19],
  "1f469-1f3fc-200d-2696-fe0f": [60, 19],
  "1f469-1f3fd-200d-2696-fe0f": [61, 19],
  "1f469-1f3fe-200d-2696-fe0f": [62, 19],
  "1f469-1f3ff-200d-2696-fe0f": [63, 19],
  "1f468-200d-2696-fe0f": [0, 20],
  "1f468-1f3fb-200d-2696-fe0f": [1, 20],
  "1f468-1f3fc-200d-2696-fe0f": [2, 20],
  "1f468-1f3fd-200d-2696-fe0f": [3, 20],
  "1f468-1f3fe-200d-2696-fe0f": [4, 20],
  "1f468-1f3ff-200d-2696-fe0f": [5, 20],
  "1f936": [6, 20],
  "1f936-1f3fb": [7, 20],
  "1f936-1f3fc": [8, 20],
  "1f936-1f3fd": [9, 20],
  "1f936-1f3fe": [10, 20],
  "1f936-1f3ff": [11, 20],
  "1f385": [12, 20],
  "1f385-1f3fb": [13, 20],
  "1f385-1f3fc": [14, 20],
  "1f385-1f3fd": [15, 20],
  "1f385-1f3fe": [16, 20],
  "1f385-1f3ff": [17, 20],
  "1f478": [18, 20],
  "1f478-1f3fb": [19, 20],
  "1f478-1f3fc": [20, 20],
  "1f478-1f3fd": [21, 20],
  "1f478-1f3fe": [22, 20],
  "1f478-1f3ff": [23, 20],
  "1f934": [24, 20],
  "1f934-1f3fb": [25, 20],
  "1f934-1f3fc": [26, 20],
  "1f934-1f3fd": [27, 20],
  "1f934-1f3fe": [28, 20],
  "1f934-1f3ff": [29, 20],
  "1f470": [30, 20],
  "1f470-1f3fb": [31, 20],
  "1f470-1f3fc": [32, 20],
  "1f470-1f3fd": [33, 20],
  "1f470-1f3fe": [34, 20],
  "1f470-1f3ff": [35, 20],
  "1f935": [36, 20],
  "1f935-1f3fb": [37, 20],
  "1f935-1f3fc": [38, 20],
  "1f935-1f3fd": [39, 20],
  "1f935-1f3fe": [40, 20],
  "1f935-1f3ff": [41, 20],
  "1f47c": [42, 20],
  "1f47c-1f3fb": [43, 20],
  "1f47c-1f3fc": [44, 20],
  "1f47c-1f3fd": [45, 20],
  "1f47c-1f3fe": [46, 20],
  "1f47c-1f3ff": [47, 20],
  "1f930": [48, 20],
  "1f930-1f3fb": [49, 20],
  "1f930-1f3fc": [50, 20],
  "1f930-1f3fd": [51, 20],
  "1f930-1f3fe": [52, 20],
  "1f930-1f3ff": [53, 20],
  "1f647-200d-2640-fe0f": [54, 20],
  "1f647-1f3fb-200d-2640-fe0f": [55, 20],
  "1f647-1f3fc-200d-2640-fe0f": [56, 20],
  "1f647-1f3fd-200d-2640-fe0f": [57, 20],
  "1f647-1f3fe-200d-2640-fe0f": [58, 20],
  "1f647-1f3ff-200d-2640-fe0f": [59, 20],
  "1f647": [60, 20],
  "1f647-1f3fb": [61, 20],
  "1f647-1f3fc": [62, 20],
  "1f647-1f3fd": [63, 20],
  "1f647-1f3fe": [0, 21],
  "1f647-1f3ff": [1, 21],
  "1f647-200d-2642-fe0f": [2, 21],
  "1f647-1f3ff-200d-2642-fe0f": [3, 21],
  "1f647-1f3fe-200d-2642-fe0f": [4, 21],
  "1f647-1f3fd-200d-2642-fe0f": [5, 21],
  "1f647-1f3fc-200d-2642-fe0f": [6, 21],
  "1f647-1f3fb-200d-2642-fe0f": [7, 21],
  "1f481": [8, 21],
  "1f481-1f3fb": [9, 21],
  "1f481-1f3fc": [10, 21],
  "1f481-1f3fd": [11, 21],
  "1f481-1f3fe": [12, 21],
  "1f481-1f3ff": [13, 21],
  "1f481-200d-2642-fe0f": [14, 21],
  "1f481-1f3fb-200d-2642-fe0f": [15, 21],
  "1f481-1f3fc-200d-2642-fe0f": [16, 21],
  "1f481-1f3fd-200d-2642-fe0f": [17, 21],
  "1f481-1f3fe-200d-2642-fe0f": [18, 21],
  "1f481-1f3ff-200d-2642-fe0f": [19, 21],
  "1f481-200d-2640-fe0f": [20, 21],
  "1f481-1f3ff-200d-2640-fe0f": [21, 21],
  "1f481-1f3fe-200d-2640-fe0f": [22, 21],
  "1f481-1f3fd-200d-2640-fe0f": [23, 21],
  "1f481-1f3fc-200d-2640-fe0f": [24, 21],
  "1f481-1f3fb-200d-2640-fe0f": [25, 21],
  "1f645": [26, 21],
  "1f645-1f3fb": [27, 21],
  "1f645-1f3fc": [28, 21],
  "1f645-1f3fd": [29, 21],
  "1f645-1f3fe": [30, 21],
  "1f645-1f3ff": [31, 21],
  "1f645-200d-2642-fe0f": [32, 21],
  "1f645-1f3fb-200d-2642-fe0f": [33, 21],
  "1f645-1f3fc-200d-2642-fe0f": [34, 21],
  "1f645-1f3fd-200d-2642-fe0f": [35, 21],
  "1f645-1f3fe-200d-2642-fe0f": [36, 21],
  "1f645-1f3ff-200d-2642-fe0f": [37, 21],
  "1f645-200d-2640-fe0f": [38, 21],
  "1f645-1f3ff-200d-2640-fe0f": [39, 21],
  "1f645-1f3fe-200d-2640-fe0f": [40, 21],
  "1f645-1f3fd-200d-2640-fe0f": [41, 21],
  "1f645-1f3fc-200d-2640-fe0f": [42, 21],
  "1f645-1f3fb-200d-2640-fe0f": [43, 21],
  "1f646": [44, 21],
  "1f646-1f3fb": [45, 21],
  "1f646-1f3fc": [46, 21],
  "1f646-1f3fd": [47, 21],
  "1f646-1f3fe": [48, 21],
  "1f646-1f3ff": [49, 21],
  "1f646-200d-2642-fe0f": [50, 21],
  "1f646-1f3fb-200d-2642-fe0f": [51, 21],
  "1f646-1f3fc-200d-2642-fe0f": [52, 21],
  "1f646-1f3fd-200d-2642-fe0f": [53, 21],
  "1f646-1f3fe-200d-2642-fe0f": [54, 21],
  "1f646-1f3ff-200d-2642-fe0f": [55, 21],
  "1f646-200d-2640-fe0f": [56, 21],
  "1f646-1f3ff-200d-2640-fe0f": [57, 21],
  "1f646-1f3fe-200d-2640-fe0f": [58, 21],
  "1f646-1f3fd-200d-2640-fe0f": [59, 21],
  "1f646-1f3fc-200d-2640-fe0f": [60, 21],
  "1f646-1f3fb-200d-2640-fe0f": [61, 21],
  "1f64b": [62, 21],
  "1f64b-1f3fb": [63, 21],
  "1f64b-1f3fc": [0, 22],
  "1f64b-1f3fd": [1, 22],
  "1f64b-1f3fe": [2, 22],
  "1f64b-1f3ff": [3, 22],
  "1f64b-200d-2642-fe0f": [4, 22],
  "1f64b-1f3fb-200d-2642-fe0f": [5, 22],
  "1f64b-1f3fc-200d-2642-fe0f": [6, 22],
  "1f64b-1f3fd-200d-2642-fe0f": [7, 22],
  "1f64b-1f3fe-200d-2642-fe0f": [8, 22],
  "1f64b-1f3ff-200d-2642-fe0f": [9, 22],
  "1f64b-200d-2640-fe0f": [10, 22],
  "1f64b-1f3ff-200d-2640-fe0f": [11, 22],
  "1f64b-1f3fe-200d-2640-fe0f": [12, 22],
  "1f64b-1f3fd-200d-2640-fe0f": [13, 22],
  "1f64b-1f3fc-200d-2640-fe0f": [14, 22],
  "1f64b-1f3fb-200d-2640-fe0f": [15, 22],
  "1f926-200d-2640-fe0f": [16, 22],
  "1f926-1f3fb-200d-2640-fe0f": [17, 22],
  "1f926-1f3fc-200d-2640-fe0f": [18, 22],
  "1f926-1f3fd-200d-2640-fe0f": [19, 22],
  "1f926-1f3fe-200d-2640-fe0f": [20, 22],
  "1f926-1f3ff-200d-2640-fe0f": [21, 22],
  "1f926-200d-2642-fe0f": [22, 22],
  "1f926-1f3fb-200d-2642-fe0f": [23, 22],
  "1f926-1f3fc-200d-2642-fe0f": [24, 22],
  "1f926-1f3fd-200d-2642-fe0f": [25, 22],
  "1f926-1f3fe-200d-2642-fe0f": [26, 22],
  "1f926-1f3ff-200d-2642-fe0f": [27, 22],
  "1f926": [28, 22],
  "1f926-1f3fb": [29, 22],
  "1f926-1f3fc": [30, 22],
  "1f926-1f3fd": [31, 22],
  "1f926-1f3fe": [32, 22],
  "1f926-1f3ff": [33, 22],
  "1f937-200d-2640-fe0f": [34, 22],
  "1f937-1f3fb-200d-2640-fe0f": [35, 22],
  "1f937-1f3fc-200d-2640-fe0f": [36, 22],
  "1f937-1f3fd-200d-2640-fe0f": [37, 22],
  "1f937-1f3fe-200d-2640-fe0f": [38, 22],
  "1f937-1f3ff-200d-2640-fe0f": [39, 22],
  "1f937-200d-2642-fe0f": [40, 22],
  "1f937-1f3fb-200d-2642-fe0f": [41, 22],
  "1f937-1f3fc-200d-2642-fe0f": [42, 22],
  "1f937-1f3fd-200d-2642-fe0f": [43, 22],
  "1f937-1f3fe-200d-2642-fe0f": [44, 22],
  "1f937-1f3ff-200d-2642-fe0f": [45, 22],
  "1f937": [46, 22],
  "1f937-1f3fb": [47, 22],
  "1f937-1f3fc": [48, 22],
  "1f937-1f3fd": [49, 22],
  "1f937-1f3fe": [50, 22],
  "1f937-1f3ff": [51, 22],
  "1f64e": [52, 22],
  "1f64e-1f3fb": [53, 22],
  "1f64e-1f3fc": [54, 22],
  "1f64e-1f3fd": [55, 22],
  "1f64e-1f3fe": [56, 22],
  "1f64e-1f3ff": [57, 22],
  "1f64e-200d-2642-fe0f": [58, 22],
  "1f64e-1f3fb-200d-2642-fe0f": [59, 22],
  "1f64e-1f3fc-200d-2642-fe0f": [60, 22],
  "1f64e-1f3fd-200d-2642-fe0f": [61, 22],
  "1f64e-1f3fe-200d-2642-fe0f": [62, 22],
  "1f64e-1f3ff-200d-2642-fe0f": [63, 22],
  "1f64e-200d-2640-fe0f": [0, 23],
  "1f64e-1f3ff-200d-2640-fe0f": [1, 23],
  "1f64e-1f3fe-200d-2640-fe0f": [2, 23],
  "1f64e-1f3fd-200d-2640-fe0f": [3, 23],
  "1f64e-1f3fc-200d-2640-fe0f": [4, 23],
  "1f64e-1f3fb-200d-2640-fe0f": [5, 23],
  "1f64d": [6, 23],
  "1f64d-1f3fb": [7, 23],
  "1f64d-1f3fc": [8, 23],
  "1f64d-1f3fd": [9, 23],
  "1f64d-1f3fe": [10, 23],
  "1f64d-1f3ff": [11, 23],
  "1f64d-200d-2642-fe0f": [12, 23],
  "1f64d-1f3fb-200d-2642-fe0f": [13, 23],
  "1f64d-1f3fc-200d-2642-fe0f": [14, 23],
  "1f64d-1f3fd-200d-2642-fe0f": [15, 23],
  "1f64d-1f3fe-200d-2642-fe0f": [16, 23],
  "1f64d-1f3ff-200d-2642-fe0f": [17, 23],
  "1f64d-200d-2640-fe0f": [18, 23],
  "1f64d-1f3ff-200d-2640-fe0f": [19, 23],
  "1f64d-1f3fe-200d-2640-fe0f": [20, 23],
  "1f64d-1f3fd-200d-2640-fe0f": [21, 23],
  "1f64d-1f3fc-200d-2640-fe0f": [22, 23],
  "1f64d-1f3fb-200d-2640-fe0f": [23, 23],
  "1f487": [24, 23],
  "1f487-1f3fb": [25, 23],
  "1f487-1f3fc": [26, 23],
  "1f487-1f3fd": [27, 23],
  "1f487-1f3fe": [28, 23],
  "1f487-1f3ff": [29, 23],
  "1f487-200d-2642-fe0f": [30, 23],
  "1f487-1f3fb-200d-2642-fe0f": [31, 23],
  "1f487-1f3fc-200d-2642-fe0f": [32, 23],
  "1f487-1f3fd-200d-2642-fe0f": [33, 23],
  "1f487-1f3fe-200d-2642-fe0f": [34, 23],
  "1f487-1f3ff-200d-2642-fe0f": [35, 23],
  "1f487-200d-2640-fe0f": [36, 23],
  "1f487-1f3ff-200d-2640-fe0f": [37, 23],
  "1f487-1f3fe-200d-2640-fe0f": [38, 23],
  "1f487-1f3fd-200d-2640-fe0f": [39, 23],
  "1f487-1f3fc-200d-2640-fe0f": [40, 23],
  "1f487-1f3fb-200d-2640-fe0f": [41, 23],
  "1f486": [42, 23],
  "1f486-1f3fb": [43, 23],
  "1f486-1f3fc": [44, 23],
  "1f486-1f3fd": [45, 23],
  "1f486-1f3fe": [46, 23],
  "1f486-1f3ff": [47, 23],
  "1f486-200d-2642-fe0f": [48, 23],
  "1f486-1f3fb-200d-2642-fe0f": [49, 23],
  "1f486-1f3fc-200d-2642-fe0f": [50, 23],
  "1f486-1f3fd-200d-2642-fe0f": [51, 23],
  "1f486-1f3fe-200d-2642-fe0f": [52, 23],
  "1f486-1f3ff-200d-2642-fe0f": [53, 23],
  "1f486-200d-2640-fe0f": [54, 23],
  "1f486-1f3ff-200d-2640-fe0f": [55, 23],
  "1f486-1f3fe-200d-2640-fe0f": [56, 23],
  "1f486-1f3fd-200d-2640-fe0f": [57, 23],
  "1f486-1f3fc-200d-2640-fe0f": [58, 23],
  "1f486-1f3fb-200d-2640-fe0f": [59, 23],
  "1f574-fe0f": [60, 23],
  "1f574-1f3fb": [61, 23],
  "1f574-1f3fc": [62, 23],
  "1f574-1f3fd": [63, 23],
  "1f574-1f3fe": [0, 24],
  "1f574-1f3ff": [1, 24],
  "1f483": [2, 24],
  "1f483-1f3fb": [3, 24],
  "1f483-1f3fc": [4, 24],
  "1f483-1f3fd": [5, 24],
  "1f483-1f3fe": [6, 24],
  "1f483-1f3ff": [7, 24],
  "1f57a": [8, 24],
  "1f57a-1f3fb": [9, 24],
  "1f57a-1f3fc": [10, 24],
  "1f57a-1f3fd": [11, 24],
  "1f57a-1f3fe": [12, 24],
  "1f57a-1f3ff": [13, 24],
  "1f46f": [14, 24],
  "1f46f-200d-2642-fe0f": [15, 24],
  "1f46f-200d-2640-fe0f": [16, 24],
  "1f6b6-200d-2640-fe0f": [17, 24],
  "1f6b6-1f3fb-200d-2640-fe0f": [18, 24],
  "1f6b6-1f3fc-200d-2640-fe0f": [19, 24],
  "1f6b6-1f3fd-200d-2640-fe0f": [20, 24],
  "1f6b6-1f3fe-200d-2640-fe0f": [21, 24],
  "1f6b6-1f3ff-200d-2640-fe0f": [22, 24],
  "1f6b6": [23, 24],
  "1f6b6-1f3fb": [24, 24],
  "1f6b6-1f3fc": [25, 24],
  "1f6b6-1f3fd": [26, 24],
  "1f6b6-1f3fe": [27, 24],
  "1f6b6-1f3ff": [28, 24],
  "1f6b6-200d-2642-fe0f": [29, 24],
  "1f6b6-1f3ff-200d-2642-fe0f": [30, 24],
  "1f6b6-1f3fe-200d-2642-fe0f": [31, 24],
  "1f6b6-1f3fd-200d-2642-fe0f": [32, 24],
  "1f6b6-1f3fc-200d-2642-fe0f": [33, 24],
  "1f6b6-1f3fb-200d-2642-fe0f": [34, 24],
  "1f3c3-200d-2640-fe0f": [35, 24],
  "1f3c3-1f3fb-200d-2640-fe0f": [36, 24],
  "1f3c3-1f3fc-200d-2640-fe0f": [37, 24],
  "1f3c3-1f3fd-200d-2640-fe0f": [38, 24],
  "1f3c3-1f3fe-200d-2640-fe0f": [39, 24],
  "1f3c3-1f3ff-200d-2640-fe0f": [40, 24],
  "1f3c3": [41, 24],
  "1f3c3-1f3fb": [42, 24],
  "1f3c3-1f3fc": [43, 24],
  "1f3c3-1f3fd": [44, 24],
  "1f3c3-1f3fe": [45, 24],
  "1f3c3-1f3ff": [46, 24],
  "1f3c3-200d-2642-fe0f": [47, 24],
  "1f3c3-1f3ff-200d-2642-fe0f": [48, 24],
  "1f3c3-1f3fe-200d-2642-fe0f": [49, 24],
  "1f3c3-1f3fd-200d-2642-fe0f": [50, 24],
  "1f3c3-1f3fc-200d-2642-fe0f": [51, 24],
  "1f3c3-1f3fb-200d-2642-fe0f": [52, 24],
  "1f46b": [53, 24],
  "1f46d": [54, 24],
  "1f46c": [55, 24],
  "1f491": [56, 24],
  "1f469-200d-2764-fe0f-200d-1f469": [57, 24],
  "1f468-200d-2764-fe0f-200d-1f468": [58, 24],
  "1f48f": [59, 24],
  "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469": [60, 24],
  "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468": [61, 24],
  "1f46a": [62, 24],
  "1f468-200d-1f469-200d-1f467": [63, 24],
  "1f468-200d-1f469-200d-1f467-200d-1f466": [0, 25],
  "1f468-200d-1f469-200d-1f466-200d-1f466": [1, 25],
  "1f468-200d-1f469-200d-1f467-200d-1f467": [2, 25],
  "1f469-200d-1f469-200d-1f466": [3, 25],
  "1f469-200d-1f469-200d-1f467": [4, 25],
  "1f469-200d-1f469-200d-1f467-200d-1f466": [5, 25],
  "1f469-200d-1f469-200d-1f466-200d-1f466": [6, 25],
  "1f469-200d-1f469-200d-1f467-200d-1f467": [7, 25],
  "1f468-200d-1f468-200d-1f466": [8, 25],
  "1f468-200d-1f468-200d-1f467": [9, 25],
  "1f468-200d-1f468-200d-1f467-200d-1f466": [10, 25],
  "1f468-200d-1f468-200d-1f466-200d-1f466": [11, 25],
  "1f468-200d-1f468-200d-1f467-200d-1f467": [12, 25],
  "1f469-200d-1f466": [13, 25],
  "1f469-200d-1f467": [14, 25],
  "1f469-200d-1f467-200d-1f466": [15, 25],
  "1f469-200d-1f466-200d-1f466": [16, 25],
  "1f469-200d-1f467-200d-1f467": [17, 25],
  "1f468-200d-1f466": [18, 25],
  "1f468-200d-1f467": [19, 25],
  "1f468-200d-1f467-200d-1f466": [20, 25],
  "1f468-200d-1f466-200d-1f466": [21, 25],
  "1f468-200d-1f467-200d-1f467": [22, 25],
  "1f45a": [23, 25],
  "1f455": [24, 25],
  "1f456": [25, 25],
  "1f454": [26, 25],
  "1f457": [27, 25],
  "1f459": [28, 25],
  "1f458": [29, 25],
  "1f460": [30, 25],
  "1f461": [31, 25],
  "1f462": [32, 25],
  "1f45e": [33, 25],
  "1f45f": [34, 25],
  "1f452": [35, 25],
  "1f3a9": [36, 25],
  "1f393": [37, 25],
  "1f451": [38, 25],
  "26d1-fe0f": [39, 25],
  "1f392": [40, 25],
  "1f45d": [41, 25],
  "1f45b": [42, 25],
  "1f45c": [43, 25],
  "1f4bc": [44, 25],
  "1f453": [45, 25],
  "1f576-fe0f": [46, 25],
  "1f302": [47, 25],
  "1f468-200d-1f469-200d-1f466": [48, 25],
  "1f469-200d-2764-fe0f-200d-1f468": [49, 25],
  "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468": [50, 25],
  "1f928": [51, 25],
  "1f929": [52, 25],
  "1f92a": [53, 25],
  "1f92b": [54, 25],
  "1f92c": [55, 25],
  "1f92d": [56, 25],
  "1f92e": [57, 25],
  "1f92f": [58, 25],
  "1f9d0": [59, 25],
  "1f9d1": [60, 25],
  "1f9d2": [61, 25],
  "1f9d3": [62, 25],
  "1f9d4": [63, 25],
  "1f9d5": [0, 26],
  "1f9e0": [1, 26],
  "1f9e2": [2, 26],
  "1f9d9": [3, 26],
  "1f9da": [4, 26],
  "1f9db": [5, 26],
  "1f9dc": [6, 26],
  "1f9dd": [7, 26],
  "1f9de": [8, 26],
  "1f9df": [9, 26],
  "1f9e3": [10, 26],
  "1f9e4": [11, 26],
  "1f9e5": [12, 26],
  "1f9e6": [13, 26],
  "1f91f": [14, 26],
  "1f91f-1f3fb": [15, 26],
  "1f91f-1f3fc": [16, 26],
  "1f91f-1f3fd": [17, 26],
  "1f91f-1f3fe": [18, 26],
  "1f91f-1f3ff": [19, 26],
  "1f932": [20, 26],
  "1f932-1f3fb": [21, 26],
  "1f932-1f3fc": [22, 26],
  "1f932-1f3fd": [23, 26],
  "1f932-1f3fe": [24, 26],
  "1f932-1f3ff": [25, 26],
  "1f9d1-1f3fb": [26, 26],
  "1f9d1-1f3fc": [27, 26],
  "1f9d1-1f3fd": [28, 26],
  "1f9d1-1f3fe": [29, 26],
  "1f9d1-1f3ff": [30, 26],
  "1f9d2-1f3fb": [31, 26],
  "1f9d2-1f3fc": [32, 26],
  "1f9d2-1f3fd": [33, 26],
  "1f9d2-1f3fe": [34, 26],
  "1f9d2-1f3ff": [35, 26],
  "1f9d3-1f3fb": [36, 26],
  "1f9d3-1f3fc": [37, 26],
  "1f9d3-1f3fd": [38, 26],
  "1f9d3-1f3fe": [39, 26],
  "1f9d3-1f3ff": [40, 26],
  "1f9d4-1f3fb": [41, 26],
  "1f9d4-1f3fc": [42, 26],
  "1f9d4-1f3fd": [43, 26],
  "1f9d4-1f3fe": [44, 26],
  "1f9d4-1f3ff": [45, 26],
  "1f9d5-1f3fb": [46, 26],
  "1f9d5-1f3fc": [47, 26],
  "1f9d5-1f3fd": [48, 26],
  "1f9d5-1f3fe": [49, 26],
  "1f9d5-1f3ff": [50, 26],
  "1f9d9-1f3fb": [51, 26],
  "1f9d9-1f3fc": [52, 26],
  "1f9d9-1f3fd": [53, 26],
  "1f9d9-1f3fe": [54, 26],
  "1f9d9-1f3ff": [55, 26],
  "1f9da-1f3fb": [56, 26],
  "1f9da-1f3fc": [57, 26],
  "1f9da-1f3fd": [58, 26],
  "1f9da-1f3fe": [59, 26],
  "1f9da-1f3ff": [60, 26],
  "1f9db-1f3fb": [61, 26],
  "1f9db-1f3fc": [62, 26],
  "1f9db-1f3fd": [63, 26],
  "1f9db-1f3fe": [0, 27],
  "1f9db-1f3ff": [1, 27],
  "1f9dc-1f3fb": [2, 27],
  "1f9dc-1f3fc": [3, 27],
  "1f9dc-1f3fd": [4, 27],
  "1f9dc-1f3fe": [5, 27],
  "1f9dc-1f3ff": [6, 27],
  "1f9dd-1f3fb": [7, 27],
  "1f9dd-1f3fc": [8, 27],
  "1f9dd-1f3fd": [9, 27],
  "1f9dd-1f3fe": [10, 27],
  "1f9dd-1f3ff": [11, 27],
  "1f9d9-200d-2640-fe0f": [12, 27],
  "1f9d9-200d-2642-fe0f": [13, 27],
  "1f9d9-1f3fb-200d-2640-fe0f": [14, 27],
  "1f9d9-1f3fb-200d-2642-fe0f": [15, 27],
  "1f9d9-1f3fc-200d-2640-fe0f": [16, 27],
  "1f9d9-1f3fc-200d-2642-fe0f": [17, 27],
  "1f9d9-1f3fd-200d-2640-fe0f": [18, 27],
  "1f9d9-1f3fd-200d-2642-fe0f": [19, 27],
  "1f9d9-1f3fe-200d-2640-fe0f": [20, 27],
  "1f9d9-1f3fe-200d-2642-fe0f": [21, 27],
  "1f9d9-1f3ff-200d-2640-fe0f": [22, 27],
  "1f9d9-1f3ff-200d-2642-fe0f": [23, 27],
  "1f9da-200d-2640-fe0f": [24, 27],
  "1f9da-200d-2642-fe0f": [25, 27],
  "1f9da-1f3fb-200d-2640-fe0f": [26, 27],
  "1f9da-1f3fb-200d-2642-fe0f": [27, 27],
  "1f9da-1f3fc-200d-2640-fe0f": [28, 27],
  "1f9da-1f3fc-200d-2642-fe0f": [29, 27],
  "1f9da-1f3fd-200d-2640-fe0f": [30, 27],
  "1f9da-1f3fd-200d-2642-fe0f": [31, 27],
  "1f9da-1f3fe-200d-2640-fe0f": [32, 27],
  "1f9da-1f3fe-200d-2642-fe0f": [33, 27],
  "1f9da-1f3ff-200d-2640-fe0f": [34, 27],
  "1f9da-1f3ff-200d-2642-fe0f": [35, 27],
  "1f9db-200d-2640-fe0f": [36, 27],
  "1f9db-200d-2642-fe0f": [37, 27],
  "1f9db-1f3fb-200d-2640-fe0f": [38, 27],
  "1f9db-1f3fb-200d-2642-fe0f": [39, 27],
  "1f9db-1f3fc-200d-2640-fe0f": [40, 27],
  "1f9db-1f3fc-200d-2642-fe0f": [41, 27],
  "1f9db-1f3fd-200d-2640-fe0f": [42, 27],
  "1f9db-1f3fd-200d-2642-fe0f": [43, 27],
  "1f9db-1f3fe-200d-2640-fe0f": [44, 27],
  "1f9db-1f3fe-200d-2642-fe0f": [45, 27],
  "1f9db-1f3ff-200d-2640-fe0f": [46, 27],
  "1f9db-1f3ff-200d-2642-fe0f": [47, 27],
  "1f9dc-200d-2640-fe0f": [48, 27],
  "1f9dc-200d-2642-fe0f": [49, 27],
  "1f9dc-1f3fb-200d-2640-fe0f": [50, 27],
  "1f9dc-1f3fb-200d-2642-fe0f": [51, 27],
  "1f9dc-1f3fc-200d-2640-fe0f": [52, 27],
  "1f9dc-1f3fc-200d-2642-fe0f": [53, 27],
  "1f9dc-1f3fd-200d-2640-fe0f": [54, 27],
  "1f9dc-1f3fd-200d-2642-fe0f": [55, 27],
  "1f9dc-1f3fe-200d-2640-fe0f": [56, 27],
  "1f9dc-1f3fe-200d-2642-fe0f": [57, 27],
  "1f9dc-1f3ff-200d-2640-fe0f": [58, 27],
  "1f9dc-1f3ff-200d-2642-fe0f": [59, 27],
  "1f9dd-200d-2640-fe0f": [60, 27],
  "1f9dd-200d-2642-fe0f": [61, 27],
  "1f9dd-1f3fb-200d-2640-fe0f": [62, 27],
  "1f9dd-1f3fb-200d-2642-fe0f": [63, 27],
  "1f9dd-1f3fc-200d-2640-fe0f": [0, 28],
  "1f9dd-1f3fc-200d-2642-fe0f": [1, 28],
  "1f9dd-1f3fd-200d-2640-fe0f": [2, 28],
  "1f9dd-1f3fd-200d-2642-fe0f": [3, 28],
  "1f9dd-1f3fe-200d-2640-fe0f": [4, 28],
  "1f9dd-1f3fe-200d-2642-fe0f": [5, 28],
  "1f9dd-1f3ff-200d-2640-fe0f": [6, 28],
  "1f9dd-1f3ff-200d-2642-fe0f": [7, 28],
  "1f9de-200d-2640-fe0f": [8, 28],
  "1f9de-200d-2642-fe0f": [9, 28],
  "1f9df-200d-2640-fe0f": [10, 28],
  "1f9df-200d-2642-fe0f": [11, 28],
  "1f34f": [13, 28],
  "1f34e": [14, 28],
  "1f350": [15, 28],
  "1f34a": [16, 28],
  "1f34b": [17, 28],
  "1f34c": [18, 28],
  "1f349": [19, 28],
  "1f347": [20, 28],
  "1f353": [21, 28],
  "1f348": [22, 28],
  "1f352": [23, 28],
  "1f351": [24, 28],
  "1f34d": [25, 28],
  "1f95d": [26, 28],
  "1f951": [27, 28],
  "1f345": [28, 28],
  "1f346": [29, 28],
  "1f952": [30, 28],
  "1f955": [31, 28],
  "1f33d": [32, 28],
  "1f336-fe0f": [33, 28],
  "1f954": [34, 28],
  "1f360": [35, 28],
  "1f330": [36, 28],
  "1f95c": [37, 28],
  "1f36f": [38, 28],
  "1f950": [39, 28],
  "1f35e": [40, 28],
  "1f956": [41, 28],
  "1f9c0": [42, 28],
  "1f95a": [43, 28],
  "1f373": [44, 28],
  "1f953": [45, 28],
  "1f95e": [46, 28],
  "1f364": [47, 28],
  "1f357": [48, 28],
  "1f356": [49, 28],
  "1f355": [50, 28],
  "1f32d": [51, 28],
  "1f354": [52, 28],
  "1f35f": [53, 28],
  "1f959": [54, 28],
  "1f32e": [55, 28],
  "1f32f": [56, 28],
  "1f957": [57, 28],
  "1f958": [58, 28],
  "1f35d": [59, 28],
  "1f35c": [60, 28],
  "1f372": [61, 28],
  "1f365": [62, 28],
  "1f363": [63, 28],
  "1f371": [0, 29],
  "1f35b": [1, 29],
  "1f359": [2, 29],
  "1f35a": [3, 29],
  "1f358": [4, 29],
  "1f362": [5, 29],
  "1f361": [6, 29],
  "1f367": [7, 29],
  "1f368": [8, 29],
  "1f366": [9, 29],
  "1f370": [10, 29],
  "1f382": [11, 29],
  "1f36e": [12, 29],
  "1f36d": [13, 29],
  "1f36c": [14, 29],
  "1f36b": [15, 29],
  "1f37f": [16, 29],
  "1f369": [17, 29],
  "1f36a": [18, 29],
  "1f95b": [19, 29],
  "1f37c": [20, 29],
  "1f375": [21, 29],
  "1f376": [22, 29],
  "1f37a": [23, 29],
  "1f37b": [24, 29],
  "1f942": [25, 29],
  "1f377": [26, 29],
  "1f943": [27, 29],
  "1f378": [28, 29],
  "1f379": [29, 29],
  "1f37e": [30, 29],
  "1f944": [31, 29],
  "1f374": [32, 29],
  "1f37d-fe0f": [33, 29],
  "1f95f": [34, 29],
  "1f960": [35, 29],
  "1f961": [36, 29],
  "1f962": [37, 29],
  "1f963": [38, 29],
  "1f964": [39, 29],
  "1f965": [40, 29],
  "1f966": [41, 29],
  "1f967": [42, 29],
  "1f968": [43, 29],
  "1f969": [44, 29],
  "1f96a": [45, 29],
  "1f96b": [46, 29],
  "2708-fe0f": [48, 29],
  "1f697": [49, 29],
  "1f695": [50, 29],
  "1f699": [51, 29],
  "1f68c": [52, 29],
  "1f68e": [53, 29],
  "1f3ce-fe0f": [54, 29],
  "1f693": [55, 29],
  "1f691": [56, 29],
  "1f692": [57, 29],
  "1f690": [58, 29],
  "1f69a": [59, 29],
  "1f69b": [60, 29],
  "1f69c": [61, 29],
  "1f6f4": [62, 29],
  "1f6b2": [63, 29],
  "1f6f5": [0, 30],
  "1f3cd-fe0f": [1, 30],
  "1f6a8": [2, 30],
  "1f694": [3, 30],
  "1f68d": [4, 30],
  "1f698": [5, 30],
  "1f696": [6, 30],
  "1f6a1": [7, 30],
  "1f6a0": [8, 30],
  "1f69f": [9, 30],
  "1f683": [10, 30],
  "1f68b": [11, 30],
  "1f69e": [12, 30],
  "1f69d": [13, 30],
  "1f684": [14, 30],
  "1f685": [15, 30],
  "1f688": [16, 30],
  "1f682": [17, 30],
  "1f686": [18, 30],
  "1f687": [19, 30],
  "1f68a": [20, 30],
  "1f689": [21, 30],
  "1f681": [22, 30],
  "1f6e9-fe0f": [23, 30],
  "1f6eb": [24, 30],
  "1f6ec": [25, 30],
  "1f680": [26, 30],
  "1f6f0-fe0f": [27, 30],
  "1f4ba": [28, 30],
  "1f6f6": [29, 30],
  "26f5": [30, 30],
  "1f6e5-fe0f": [31, 30],
  "1f6a4": [32, 30],
  "1f6f3-fe0f": [33, 30],
  "26f4-fe0f": [34, 30],
  "1f6a2": [35, 30],
  "1f6a7": [36, 30],
  "26fd": [37, 30],
  "1f68f": [38, 30],
  "1f6a6": [39, 30],
  "1f6a5": [40, 30],
  "1f5fa-fe0f": [41, 30],
  "1f5ff": [42, 30],
  "1f5fd": [43, 30],
  "26f2": [44, 30],
  "1f5fc": [45, 30],
  "1f3f0": [46, 30],
  "1f3ef": [47, 30],
  "1f3df-fe0f": [48, 30],
  "1f3a1": [49, 30],
  "1f3a2": [50, 30],
  "1f3a0": [51, 30],
  "26f1-fe0f": [52, 30],
  "1f3d6-fe0f": [53, 30],
  "1f3dd-fe0f": [54, 30],
  "26f0-fe0f": [55, 30],
  "1f3d4-fe0f": [56, 30],
  "1f5fb": [57, 30],
  "1f30b": [58, 30],
  "1f3dc-fe0f": [59, 30],
  "1f3d5-fe0f": [60, 30],
  "26fa": [61, 30],
  "1f6e4-fe0f": [62, 30],
  "1f6e3-fe0f": [63, 30],
  "1f3d7-fe0f": [0, 31],
  "1f3ed": [1, 31],
  "1f3e0": [2, 31],
  "1f3e1": [3, 31],
  "1f3d8-fe0f": [4, 31],
  "1f3da-fe0f": [5, 31],
  "1f3e2": [6, 31],
  "1f3ec": [7, 31],
  "1f3e3": [8, 31],
  "1f3e4": [9, 31],
  "1f3e5": [10, 31],
  "1f3e6": [11, 31],
  "1f3e8": [12, 31],
  "1f3ea": [13, 31],
  "1f3eb": [14, 31],
  "1f3e9": [15, 31],
  "1f492": [16, 31],
  "1f3db-fe0f": [17, 31],
  "26ea": [18, 31],
  "1f54c": [19, 31],
  "1f54d": [20, 31],
  "1f54b": [21, 31],
  "26e9-fe0f": [22, 31],
  "1f5fe": [23, 31],
  "1f391": [24, 31],
  "1f3de-fe0f": [25, 31],
  "1f305": [26, 31],
  "1f304": [27, 31],
  "1f320": [28, 31],
  "1f387": [29, 31],
  "1f386": [30, 31],
  "1f307": [31, 31],
  "1f306": [32, 31],
  "1f3d9-fe0f": [33, 31],
  "1f303": [34, 31],
  "1f30c": [35, 31],
  "1f309": [36, 31],
  "1f301": [37, 31],
  "1f6f8": [38, 31],
  "26bd": [39, 31],
  "1f3c0": [40, 31],
  "1f3c8": [41, 31],
  "26be": [42, 31],
  "1f3be": [43, 31],
  "1f3d0": [44, 31],
  "1f3c9": [45, 31],
  "1f3b1": [46, 31],
  "1f3d3": [47, 31],
  "1f3f8": [48, 31],
  "1f945": [49, 31],
  "1f3d2": [50, 31],
  "1f3d1": [51, 31],
  "1f3cf": [52, 31],
  "26f3": [53, 31],
  "1f3f9": [54, 31],
  "1f3a3": [55, 31],
  "1f94a": [56, 31],
  "1f94b": [57, 31],
  "26f8-fe0f": [58, 31],
  "1f3bf": [59, 31],
  "26f7-fe0f": [60, 31],
  "1f3c2": [61, 31],
  "1f3c2-1f3fb": [62, 31],
  "1f3c2-1f3fc": [63, 31],
  "1f3c2-1f3fd": [0, 32],
  "1f3c2-1f3fe": [1, 32],
  "1f3c2-1f3ff": [2, 32],
  "1f3cb-fe0f-200d-2640-fe0f": [3, 32],
  "1f3cb-1f3fb-200d-2640-fe0f": [4, 32],
  "1f3cb-1f3fc-200d-2640-fe0f": [5, 32],
  "1f3cb-1f3fd-200d-2640-fe0f": [6, 32],
  "1f3cb-1f3fe-200d-2640-fe0f": [7, 32],
  "1f3cb-1f3ff-200d-2640-fe0f": [8, 32],
  "1f3cb-fe0f": [9, 32],
  "1f3cb-1f3fb": [10, 32],
  "1f3cb-1f3fc": [11, 32],
  "1f3cb-1f3fd": [12, 32],
  "1f3cb-1f3fe": [13, 32],
  "1f3cb-1f3ff": [14, 32],
  "1f3cb-fe0f-200d-2642-fe0f": [15, 32],
  "1f3cb-1f3ff-200d-2642-fe0f": [16, 32],
  "1f3cb-1f3fe-200d-2642-fe0f": [17, 32],
  "1f3cb-1f3fd-200d-2642-fe0f": [18, 32],
  "1f3cb-1f3fc-200d-2642-fe0f": [19, 32],
  "1f3cb-1f3fb-200d-2642-fe0f": [20, 32],
  "1f93a": [21, 32],
  "1f93c-200d-2640-fe0f": [22, 32],
  "1f93c-200d-2642-fe0f": [23, 32],
  "1f93c": [24, 32],
  "1f938-200d-2640-fe0f": [25, 32],
  "1f938-1f3fb-200d-2640-fe0f": [26, 32],
  "1f938-1f3fc-200d-2640-fe0f": [27, 32],
  "1f938-1f3fd-200d-2640-fe0f": [28, 32],
  "1f938-1f3fe-200d-2640-fe0f": [29, 32],
  "1f938-1f3ff-200d-2640-fe0f": [30, 32],
  "1f938-200d-2642-fe0f": [31, 32],
  "1f938-1f3fb-200d-2642-fe0f": [32, 32],
  "1f938-1f3fc-200d-2642-fe0f": [33, 32],
  "1f938-1f3fd-200d-2642-fe0f": [34, 32],
  "1f938-1f3fe-200d-2642-fe0f": [35, 32],
  "1f938-1f3ff-200d-2642-fe0f": [36, 32],
  "1f938": [37, 32],
  "1f938-1f3fb": [38, 32],
  "1f938-1f3fc": [39, 32],
  "1f938-1f3fd": [40, 32],
  "1f938-1f3fe": [41, 32],
  "1f938-1f3ff": [42, 32],
  "26f9-fe0f-200d-2640-fe0f": [43, 32],
  "26f9-1f3fb-200d-2640-fe0f": [44, 32],
  "26f9-1f3fc-200d-2640-fe0f": [45, 32],
  "26f9-1f3fd-200d-2640-fe0f": [46, 32],
  "26f9-1f3fe-200d-2640-fe0f": [47, 32],
  "26f9-1f3ff-200d-2640-fe0f": [48, 32],
  "26f9-fe0f": [49, 32],
  "26f9-1f3fb": [50, 32],
  "26f9-1f3fc": [51, 32],
  "26f9-1f3fd": [52, 32],
  "26f9-1f3fe": [53, 32],
  "26f9-1f3ff": [54, 32],
  "26f9-fe0f-200d-2642-fe0f": [55, 32],
  "26f9-1f3ff-200d-2642-fe0f": [56, 32],
  "26f9-1f3fe-200d-2642-fe0f": [57, 32],
  "26f9-1f3fd-200d-2642-fe0f": [58, 32],
  "26f9-1f3fc-200d-2642-fe0f": [59, 32],
  "26f9-1f3fb-200d-2642-fe0f": [60, 32],
  "1f93e-200d-2640-fe0f": [61, 32],
  "1f93e-1f3fb-200d-2640-fe0f": [62, 32],
  "1f93e-1f3fc-200d-2640-fe0f": [63, 32],
  "1f93e-1f3fd-200d-2640-fe0f": [0, 33],
  "1f93e-1f3fe-200d-2640-fe0f": [1, 33],
  "1f93e-1f3ff-200d-2640-fe0f": [2, 33],
  "1f93e-200d-2642-fe0f": [3, 33],
  "1f93e-1f3fb-200d-2642-fe0f": [4, 33],
  "1f93e-1f3fc-200d-2642-fe0f": [5, 33],
  "1f93e-1f3fd-200d-2642-fe0f": [6, 33],
  "1f93e-1f3fe-200d-2642-fe0f": [7, 33],
  "1f93e-1f3ff-200d-2642-fe0f": [8, 33],
  "1f93e": [9, 33],
  "1f93e-1f3fb": [10, 33],
  "1f93e-1f3fc": [11, 33],
  "1f93e-1f3fd": [12, 33],
  "1f93e-1f3fe": [13, 33],
  "1f93e-1f3ff": [14, 33],
  "1f3cc-fe0f-200d-2640-fe0f": [15, 33],
  "1f3cc-1f3fb-200d-2640-fe0f": [16, 33],
  "1f3cc-1f3fc-200d-2640-fe0f": [17, 33],
  "1f3cc-1f3fd-200d-2640-fe0f": [18, 33],
  "1f3cc-1f3fe-200d-2640-fe0f": [19, 33],
  "1f3cc-1f3ff-200d-2640-fe0f": [20, 33],
  "1f3cc-fe0f": [21, 33],
  "1f3cc-1f3fb": [22, 33],
  "1f3cc-1f3fc": [23, 33],
  "1f3cc-1f3fd": [24, 33],
  "1f3cc-1f3fe": [25, 33],
  "1f3cc-1f3ff": [26, 33],
  "1f3cc-fe0f-200d-2642-fe0f": [27, 33],
  "1f3cc-1f3fb-200d-2642-fe0f": [28, 33],
  "1f3cc-1f3fc-200d-2642-fe0f": [29, 33],
  "1f3cc-1f3fd-200d-2642-fe0f": [30, 33],
  "1f3cc-1f3fe-200d-2642-fe0f": [31, 33],
  "1f3cc-1f3ff-200d-2642-fe0f": [32, 33],
  "1f3c4-200d-2640-fe0f": [33, 33],
  "1f3c4-1f3fb-200d-2640-fe0f": [34, 33],
  "1f3c4-1f3fc-200d-2640-fe0f": [35, 33],
  "1f3c4-1f3fd-200d-2640-fe0f": [36, 33],
  "1f3c4-1f3fe-200d-2640-fe0f": [37, 33],
  "1f3c4-1f3ff-200d-2640-fe0f": [38, 33],
  "1f3c4": [39, 33],
  "1f3c4-1f3fb": [40, 33],
  "1f3c4-1f3fc": [41, 33],
  "1f3c4-1f3fd": [42, 33],
  "1f3c4-1f3fe": [43, 33],
  "1f3c4-1f3ff": [44, 33],
  "1f3c4-200d-2642-fe0f": [45, 33],
  "1f3c4-1f3ff-200d-2642-fe0f": [46, 33],
  "1f3c4-1f3fe-200d-2642-fe0f": [47, 33],
  "1f3c4-1f3fd-200d-2642-fe0f": [48, 33],
  "1f3c4-1f3fc-200d-2642-fe0f": [49, 33],
  "1f3c4-1f3fb-200d-2642-fe0f": [50, 33],
  "1f3ca-200d-2640-fe0f": [51, 33],
  "1f3ca-1f3fb-200d-2640-fe0f": [52, 33],
  "1f3ca-1f3fc-200d-2640-fe0f": [53, 33],
  "1f3ca-1f3fd-200d-2640-fe0f": [54, 33],
  "1f3ca-1f3fe-200d-2640-fe0f": [55, 33],
  "1f3ca-1f3ff-200d-2640-fe0f": [56, 33],
  "1f3ca": [57, 33],
  "1f3ca-1f3fb": [58, 33],
  "1f3ca-1f3fc": [59, 33],
  "1f3ca-1f3fd": [60, 33],
  "1f3ca-1f3fe": [61, 33],
  "1f3ca-1f3ff": [62, 33],
  "1f3ca-200d-2642-fe0f": [63, 33],
  "1f3ca-1f3ff-200d-2642-fe0f": [0, 34],
  "1f3ca-1f3fe-200d-2642-fe0f": [1, 34],
  "1f3ca-1f3fd-200d-2642-fe0f": [2, 34],
  "1f3ca-1f3fc-200d-2642-fe0f": [3, 34],
  "1f3ca-1f3fb-200d-2642-fe0f": [4, 34],
  "1f93d-200d-2640-fe0f": [5, 34],
  "1f93d-1f3fb-200d-2640-fe0f": [6, 34],
  "1f93d-1f3fc-200d-2640-fe0f": [7, 34],
  "1f93d-1f3fd-200d-2640-fe0f": [8, 34],
  "1f93d-1f3fe-200d-2640-fe0f": [9, 34],
  "1f93d-1f3ff-200d-2640-fe0f": [10, 34],
  "1f93d-200d-2642-fe0f": [11, 34],
  "1f93d-1f3fb-200d-2642-fe0f": [12, 34],
  "1f93d-1f3fc-200d-2642-fe0f": [13, 34],
  "1f93d-1f3fd-200d-2642-fe0f": [14, 34],
  "1f93d-1f3fe-200d-2642-fe0f": [15, 34],
  "1f93d-1f3ff-200d-2642-fe0f": [16, 34],
  "1f93d": [17, 34],
  "1f93d-1f3fb": [18, 34],
  "1f93d-1f3fc": [19, 34],
  "1f93d-1f3fd": [20, 34],
  "1f93d-1f3fe": [21, 34],
  "1f93d-1f3ff": [22, 34],
  "1f6a3-200d-2640-fe0f": [23, 34],
  "1f6a3-1f3fb-200d-2640-fe0f": [24, 34],
  "1f6a3-1f3fc-200d-2640-fe0f": [25, 34],
  "1f6a3-1f3fd-200d-2640-fe0f": [26, 34],
  "1f6a3-1f3fe-200d-2640-fe0f": [27, 34],
  "1f6a3-1f3ff-200d-2640-fe0f": [28, 34],
  "1f6a3": [29, 34],
  "1f6a3-1f3fb": [30, 34],
  "1f6a3-1f3fc": [31, 34],
  "1f6a3-1f3fd": [32, 34],
  "1f6a3-1f3fe": [33, 34],
  "1f6a3-1f3ff": [34, 34],
  "1f6a3-200d-2642-fe0f": [35, 34],
  "1f6a3-1f3ff-200d-2642-fe0f": [36, 34],
  "1f6a3-1f3fe-200d-2642-fe0f": [37, 34],
  "1f6a3-1f3fd-200d-2642-fe0f": [38, 34],
  "1f6a3-1f3fc-200d-2642-fe0f": [39, 34],
  "1f6a3-1f3fb-200d-2642-fe0f": [40, 34],
  "1f3c7": [41, 34],
  "1f3c7-1f3fb": [42, 34],
  "1f3c7-1f3fc": [43, 34],
  "1f3c7-1f3fd": [44, 34],
  "1f3c7-1f3fe": [45, 34],
  "1f3c7-1f3ff": [46, 34],
  "1f6b4-200d-2640-fe0f": [47, 34],
  "1f6b4-1f3fb-200d-2640-fe0f": [48, 34],
  "1f6b4-1f3fc-200d-2640-fe0f": [49, 34],
  "1f6b4-1f3fd-200d-2640-fe0f": [50, 34],
  "1f6b4-1f3fe-200d-2640-fe0f": [51, 34],
  "1f6b4-1f3ff-200d-2640-fe0f": [52, 34],
  "1f6b4": [53, 34],
  "1f6b4-1f3fb": [54, 34],
  "1f6b4-1f3fc": [55, 34],
  "1f6b4-1f3fd": [56, 34],
  "1f6b4-1f3fe": [57, 34],
  "1f6b4-1f3ff": [58, 34],
  "1f6b4-200d-2642-fe0f": [59, 34],
  "1f6b4-1f3ff-200d-2642-fe0f": [60, 34],
  "1f6b4-1f3fe-200d-2642-fe0f": [61, 34],
  "1f6b4-1f3fd-200d-2642-fe0f": [62, 34],
  "1f6b4-1f3fc-200d-2642-fe0f": [63, 34],
  "1f6b4-1f3fb-200d-2642-fe0f": [0, 35],
  "1f6b5-200d-2640-fe0f": [1, 35],
  "1f6b5-1f3fb-200d-2640-fe0f": [2, 35],
  "1f6b5-1f3fc-200d-2640-fe0f": [3, 35],
  "1f6b5-1f3fd-200d-2640-fe0f": [4, 35],
  "1f6b5-1f3fe-200d-2640-fe0f": [5, 35],
  "1f6b5-1f3ff-200d-2640-fe0f": [6, 35],
  "1f6b5": [7, 35],
  "1f6b5-1f3fb": [8, 35],
  "1f6b5-1f3fc": [9, 35],
  "1f6b5-1f3fd": [10, 35],
  "1f6b5-1f3fe": [11, 35],
  "1f6b5-1f3ff": [12, 35],
  "1f6b5-200d-2642-fe0f": [13, 35],
  "1f6b5-1f3ff-200d-2642-fe0f": [14, 35],
  "1f6b5-1f3fe-200d-2642-fe0f": [15, 35],
  "1f6b5-1f3fd-200d-2642-fe0f": [16, 35],
  "1f6b5-1f3fc-200d-2642-fe0f": [17, 35],
  "1f6b5-1f3fb-200d-2642-fe0f": [18, 35],
  "1f3bd": [19, 35],
  "1f3c5": [20, 35],
  "1f396-fe0f": [21, 35],
  "1f947": [22, 35],
  "1f948": [23, 35],
  "1f949": [24, 35],
  "1f3c6": [25, 35],
  "1f3f5-fe0f": [26, 35],
  "1f397-fe0f": [27, 35],
  "1f3ab": [28, 35],
  "1f39f-fe0f": [29, 35],
  "1f3aa": [30, 35],
  "1f939-200d-2640-fe0f": [31, 35],
  "1f939-1f3fb-200d-2640-fe0f": [32, 35],
  "1f939-1f3fc-200d-2640-fe0f": [33, 35],
  "1f939-1f3fd-200d-2640-fe0f": [34, 35],
  "1f939-1f3fe-200d-2640-fe0f": [35, 35],
  "1f939-1f3ff-200d-2640-fe0f": [36, 35],
  "1f939-200d-2642-fe0f": [37, 35],
  "1f939-1f3fb-200d-2642-fe0f": [38, 35],
  "1f939-1f3fc-200d-2642-fe0f": [39, 35],
  "1f939-1f3fd-200d-2642-fe0f": [40, 35],
  "1f939-1f3fe-200d-2642-fe0f": [41, 35],
  "1f939-1f3ff-200d-2642-fe0f": [42, 35],
  "1f939": [43, 35],
  "1f939-1f3fb": [44, 35],
  "1f939-1f3fc": [45, 35],
  "1f939-1f3fd": [46, 35],
  "1f939-1f3fe": [47, 35],
  "1f939-1f3ff": [48, 35],
  "1f3ad": [49, 35],
  "1f3a8": [50, 35],
  "1f3ac": [51, 35],
  "1f3a4": [52, 35],
  "1f3a7": [53, 35],
  "1f3bc": [54, 35],
  "1f3b9": [55, 35],
  "1f941": [56, 35],
  "1f3b7": [57, 35],
  "1f3ba": [58, 35],
  "1f3b8": [59, 35],
  "1f3bb": [60, 35],
  "1f3b2": [61, 35],
  "1f3af": [62, 35],
  "1f3b3": [63, 35],
  "1f3ae": [0, 36],
  "1f3b0": [1, 36],
  "1f6f7": [2, 36],
  "1f931": [3, 36],
  "1f94c": [4, 36],
  "1f9d6": [5, 36],
  "1f9d7": [6, 36],
  "1f9d8": [7, 36],
  "1f931-1f3fb": [8, 36],
  "1f931-1f3fc": [9, 36],
  "1f931-1f3fd": [10, 36],
  "1f931-1f3fe": [11, 36],
  "1f931-1f3ff": [12, 36],
  "1f9d6-1f3fb": [13, 36],
  "1f9d6-1f3fc": [14, 36],
  "1f9d6-1f3fd": [15, 36],
  "1f9d6-1f3fe": [16, 36],
  "1f9d6-1f3ff": [17, 36],
  "1f9d7-1f3fb": [18, 36],
  "1f9d7-1f3fc": [19, 36],
  "1f9d7-1f3fd": [20, 36],
  "1f9d7-1f3fe": [21, 36],
  "1f9d7-1f3ff": [22, 36],
  "1f9d8-1f3fb": [23, 36],
  "1f9d8-1f3fc": [24, 36],
  "1f9d8-1f3fd": [25, 36],
  "1f9d8-1f3fe": [26, 36],
  "1f9d8-1f3ff": [27, 36],
  "1f9d6-200d-2640-fe0f": [28, 36],
  "1f9d6-200d-2642-fe0f": [29, 36],
  "1f9d6-1f3fb-200d-2640-fe0f": [30, 36],
  "1f9d6-1f3fb-200d-2642-fe0f": [31, 36],
  "1f9d6-1f3fc-200d-2640-fe0f": [32, 36],
  "1f9d6-1f3fc-200d-2642-fe0f": [33, 36],
  "1f9d6-1f3fd-200d-2640-fe0f": [34, 36],
  "1f9d6-1f3fd-200d-2642-fe0f": [35, 36],
  "1f9d6-1f3fe-200d-2640-fe0f": [36, 36],
  "1f9d6-1f3fe-200d-2642-fe0f": [37, 36],
  "1f9d6-1f3ff-200d-2640-fe0f": [38, 36],
  "1f9d6-1f3ff-200d-2642-fe0f": [39, 36],
  "1f9d7-200d-2640-fe0f": [40, 36],
  "1f9d7-200d-2642-fe0f": [41, 36],
  "1f9d7-1f3fb-200d-2640-fe0f": [42, 36],
  "1f9d7-1f3fb-200d-2642-fe0f": [43, 36],
  "1f9d7-1f3fc-200d-2640-fe0f": [44, 36],
  "1f9d7-1f3fc-200d-2642-fe0f": [45, 36],
  "1f9d7-1f3fd-200d-2640-fe0f": [46, 36],
  "1f9d7-1f3fd-200d-2642-fe0f": [47, 36],
  "1f9d7-1f3fe-200d-2640-fe0f": [48, 36],
  "1f9d7-1f3fe-200d-2642-fe0f": [49, 36],
  "1f9d7-1f3ff-200d-2640-fe0f": [50, 36],
  "1f9d7-1f3ff-200d-2642-fe0f": [51, 36],
  "1f9d8-200d-2640-fe0f": [52, 36],
  "1f9d8-200d-2642-fe0f": [53, 36],
  "1f9d8-1f3fb-200d-2640-fe0f": [54, 36],
  "1f9d8-1f3fb-200d-2642-fe0f": [55, 36],
  "1f9d8-1f3fc-200d-2640-fe0f": [56, 36],
  "1f9d8-1f3fc-200d-2642-fe0f": [57, 36],
  "1f9d8-1f3fd-200d-2640-fe0f": [58, 36],
  "1f9d8-1f3fd-200d-2642-fe0f": [59, 36],
  "1f9d8-1f3fe-200d-2640-fe0f": [60, 36],
  "1f9d8-1f3fe-200d-2642-fe0f": [61, 36],
  "1f9d8-1f3ff-200d-2640-fe0f": [62, 36],
  "1f9d8-1f3ff-200d-2642-fe0f": [63, 36],
  "1f3f3-fe0f": [0, 37],
  "1f3f4": [1, 37],
  "1f3c1": [2, 37],
  "1f6a9": [3, 37],
  "1f3f3-fe0f-200d-1f308": [4, 37],
  "1f1e6-1f1eb": [5, 37],
  "1f1e6-1f1fd": [6, 37],
  "1f1e6-1f1f1": [7, 37],
  "1f1e9-1f1ff": [8, 37],
  "1f1e6-1f1f8": [9, 37],
  "1f1e6-1f1e9": [10, 37],
  "1f1e6-1f1f4": [11, 37],
  "1f1e6-1f1ee": [12, 37],
  "1f1e6-1f1f6": [13, 37],
  "1f1e6-1f1ec": [14, 37],
  "1f1e6-1f1f7": [15, 37],
  "1f1e6-1f1f2": [16, 37],
  "1f1e6-1f1fc": [17, 37],
  "1f1e6-1f1fa": [18, 37],
  "1f1e6-1f1f9": [19, 37],
  "1f1e6-1f1ff": [20, 37],
  "1f1e7-1f1f8": [21, 37],
  "1f1e7-1f1ed": [22, 37],
  "1f1e7-1f1e9": [23, 37],
  "1f1e7-1f1e7": [24, 37],
  "1f1e7-1f1fe": [25, 37],
  "1f1e7-1f1ea": [26, 37],
  "1f1e7-1f1ff": [27, 37],
  "1f1e7-1f1ef": [28, 37],
  "1f1e7-1f1f2": [29, 37],
  "1f1e7-1f1f9": [30, 37],
  "1f1e7-1f1f4": [31, 37],
  "1f1e7-1f1e6": [32, 37],
  "1f1e7-1f1fc": [33, 37],
  "1f1e7-1f1f7": [34, 37],
  "1f1ee-1f1f4": [35, 37],
  "1f1fb-1f1ec": [36, 37],
  "1f1e7-1f1f3": [37, 37],
  "1f1e7-1f1ec": [38, 37],
  "1f1e7-1f1eb": [39, 37],
  "1f1e7-1f1ee": [40, 37],
  "1f1f0-1f1ed": [41, 37],
  "1f1e8-1f1f2": [42, 37],
  "1f1e8-1f1e6": [43, 37],
  "1f1ee-1f1e8": [44, 37],
  "1f1e8-1f1fb": [45, 37],
  "1f1e7-1f1f6": [46, 37],
  "1f1f0-1f1fe": [47, 37],
  "1f1e8-1f1eb": [48, 37],
  "1f1f9-1f1e9": [49, 37],
  "1f1e8-1f1f1": [50, 37],
  "1f1e8-1f1f3": [51, 37],
  "1f1e8-1f1fd": [52, 37],
  "1f1e8-1f1e8": [53, 37],
  "1f1e8-1f1f4": [54, 37],
  "1f1f0-1f1f2": [55, 37],
  "1f1e8-1f1ec": [56, 37],
  "1f1e8-1f1e9": [57, 37],
  "1f1e8-1f1f0": [58, 37],
  "1f1e8-1f1f7": [59, 37],
  "1f1e8-1f1ee": [60, 37],
  "1f1ed-1f1f7": [61, 37],
  "1f1e8-1f1fa": [62, 37],
  "1f1e8-1f1fc": [63, 37],
  "1f1e8-1f1fe": [0, 38],
  "1f1e8-1f1ff": [1, 38],
  "1f1e9-1f1f0": [2, 38],
  "1f1e9-1f1ef": [3, 38],
  "1f1e9-1f1f2": [4, 38],
  "1f1e9-1f1f4": [5, 38],
  "1f1ea-1f1e8": [6, 38],
  "1f1ea-1f1ec": [7, 38],
  "1f1f8-1f1fb": [8, 38],
  "1f1ec-1f1f6": [9, 38],
  "1f1ea-1f1f7": [10, 38],
  "1f1ea-1f1ea": [11, 38],
  "1f1ea-1f1f9": [12, 38],
  "1f1ea-1f1fa": [13, 38],
  "1f1eb-1f1f0": [14, 38],
  "1f1eb-1f1f4": [15, 38],
  "1f1eb-1f1ef": [16, 38],
  "1f1eb-1f1ee": [17, 38],
  "1f1eb-1f1f7": [18, 38],
  "1f1ec-1f1eb": [19, 38],
  "1f1f5-1f1eb": [20, 38],
  "1f1f9-1f1eb": [21, 38],
  "1f1ec-1f1e6": [22, 38],
  "1f1ec-1f1f2": [23, 38],
  "1f1ec-1f1ea": [24, 38],
  "1f1e9-1f1ea": [25, 38],
  "1f1ec-1f1ed": [26, 38],
  "1f1ec-1f1ee": [27, 38],
  "1f1ec-1f1f7": [28, 38],
  "1f1ec-1f1f1": [29, 38],
  "1f1ec-1f1e9": [30, 38],
  "1f1ec-1f1f5": [31, 38],
  "1f1ec-1f1fa": [32, 38],
  "1f1ec-1f1f9": [33, 38],
  "1f1ec-1f1ec": [34, 38],
  "1f1ec-1f1f3": [35, 38],
  "1f1ec-1f1fc": [36, 38],
  "1f1ec-1f1fe": [37, 38],
  "1f1ed-1f1f9": [38, 38],
  "1f1ed-1f1f3": [39, 38],
  "1f1ed-1f1f0": [40, 38],
  "1f1ed-1f1fa": [41, 38],
  "1f1ee-1f1f8": [42, 38],
  "1f1ee-1f1f3": [43, 38],
  "1f1ee-1f1e9": [44, 38],
  "1f1ee-1f1f7": [45, 38],
  "1f1ee-1f1f6": [46, 38],
  "1f1ee-1f1ea": [47, 38],
  "1f1ee-1f1f2": [48, 38],
  "1f1ee-1f1f1": [49, 38],
  "1f1ee-1f1f9": [50, 38],
  "1f1ef-1f1f2": [51, 38],
  "1f1ef-1f1f5": [52, 38],
  "1f38c": [53, 38],
  "1f1ef-1f1ea": [54, 38],
  "1f1ef-1f1f4": [55, 38],
  "1f1f0-1f1ff": [56, 38],
  "1f1f0-1f1ea": [57, 38],
  "1f1f0-1f1ee": [58, 38],
  "1f1fd-1f1f0": [59, 38],
  "1f1f0-1f1fc": [60, 38],
  "1f1f0-1f1ec": [61, 38],
  "1f1f1-1f1e6": [62, 38],
  "1f1f1-1f1fb": [63, 38],
  "1f1f1-1f1e7": [0, 39],
  "1f1f1-1f1f8": [1, 39],
  "1f1f1-1f1f7": [2, 39],
  "1f1f1-1f1fe": [3, 39],
  "1f1f1-1f1ee": [4, 39],
  "1f1f1-1f1f9": [5, 39],
  "1f1f1-1f1fa": [6, 39],
  "1f1f2-1f1f4": [7, 39],
  "1f1f2-1f1f0": [8, 39],
  "1f1f2-1f1ec": [9, 39],
  "1f1f2-1f1fc": [10, 39],
  "1f1f2-1f1fe": [11, 39],
  "1f1f2-1f1fb": [12, 39],
  "1f1f2-1f1f1": [13, 39],
  "1f1f2-1f1f9": [14, 39],
  "1f1f2-1f1ed": [15, 39],
  "1f1f2-1f1f6": [16, 39],
  "1f1f2-1f1f7": [17, 39],
  "1f1f2-1f1fa": [18, 39],
  "1f1fe-1f1f9": [19, 39],
  "1f1f2-1f1fd": [20, 39],
  "1f1eb-1f1f2": [21, 39],
  "1f1f2-1f1e9": [22, 39],
  "1f1f2-1f1e8": [23, 39],
  "1f1f2-1f1f3": [24, 39],
  "1f1f2-1f1ea": [25, 39],
  "1f1f2-1f1f8": [26, 39],
  "1f1f2-1f1e6": [27, 39],
  "1f1f2-1f1ff": [28, 39],
  "1f1f2-1f1f2": [29, 39],
  "1f1f3-1f1e6": [30, 39],
  "1f1f3-1f1f7": [31, 39],
  "1f1f3-1f1f5": [32, 39],
  "1f1f3-1f1f1": [33, 39],
  "1f1f3-1f1e8": [34, 39],
  "1f1f3-1f1ff": [35, 39],
  "1f1f3-1f1ee": [36, 39],
  "1f1f3-1f1ea": [37, 39],
  "1f1f3-1f1ec": [38, 39],
  "1f1f3-1f1fa": [39, 39],
  "1f1f3-1f1eb": [40, 39],
  "1f1f0-1f1f5": [41, 39],
  "1f1f2-1f1f5": [42, 39],
  "1f1f3-1f1f4": [43, 39],
  "1f1f4-1f1f2": [44, 39],
  "1f1f5-1f1f0": [45, 39],
  "1f1f5-1f1fc": [46, 39],
  "1f1f5-1f1f8": [47, 39],
  "1f1f5-1f1e6": [48, 39],
  "1f1f5-1f1ec": [49, 39],
  "1f1f5-1f1fe": [50, 39],
  "1f1f5-1f1ea": [51, 39],
  "1f1f5-1f1ed": [52, 39],
  "1f1f5-1f1f3": [53, 39],
  "1f1f5-1f1f1": [54, 39],
  "1f1f5-1f1f9": [55, 39],
  "1f1f5-1f1f7": [56, 39],
  "1f1f6-1f1e6": [57, 39],
  "1f1f7-1f1ea": [58, 39],
  "1f1f7-1f1f4": [59, 39],
  "1f1f7-1f1fa": [60, 39],
  "1f1f7-1f1fc": [61, 39],
  "1f1fc-1f1f8": [62, 39],
  "1f1f8-1f1f2": [63, 39],
  "1f1f8-1f1f9": [0, 40],
  "1f1f8-1f1e6": [1, 40],
  "1f1f8-1f1f3": [2, 40],
  "1f1f7-1f1f8": [3, 40],
  "1f1f8-1f1e8": [4, 40],
  "1f1f8-1f1f1": [5, 40],
  "1f1f8-1f1ec": [6, 40],
  "1f1f8-1f1fd": [7, 40],
  "1f1f8-1f1f0": [8, 40],
  "1f1f8-1f1ee": [9, 40],
  "1f1ec-1f1f8": [10, 40],
  "1f1f8-1f1e7": [11, 40],
  "1f1f8-1f1f4": [12, 40],
  "1f1ff-1f1e6": [13, 40],
  "1f1f0-1f1f7": [14, 40],
  "1f1f8-1f1f8": [15, 40],
  "1f1ea-1f1f8": [16, 40],
  "1f1f1-1f1f0": [17, 40],
  "1f1e7-1f1f1": [18, 40],
  "1f1f8-1f1ed": [19, 40],
  "1f1f0-1f1f3": [20, 40],
  "1f1f1-1f1e8": [21, 40],
  "1f1f5-1f1f2": [22, 40],
  "1f1fb-1f1e8": [23, 40],
  "1f1f8-1f1e9": [24, 40],
  "1f1f8-1f1f7": [25, 40],
  "1f1f8-1f1ff": [26, 40],
  "1f1f8-1f1ea": [27, 40],
  "1f1e8-1f1ed": [28, 40],
  "1f1f8-1f1fe": [29, 40],
  "1f1f9-1f1fc": [30, 40],
  "1f1f9-1f1ef": [31, 40],
  "1f1f9-1f1ff": [32, 40],
  "1f1f9-1f1ed": [33, 40],
  "1f1f9-1f1f1": [34, 40],
  "1f1f9-1f1ec": [35, 40],
  "1f1f9-1f1f0": [36, 40],
  "1f1f9-1f1f4": [37, 40],
  "1f1f9-1f1f9": [38, 40],
  "1f1f9-1f1f3": [39, 40],
  "1f1f9-1f1f7": [40, 40],
  "1f1f9-1f1f2": [41, 40],
  "1f1f9-1f1e8": [42, 40],
  "1f1f9-1f1fb": [43, 40],
  "1f1fb-1f1ee": [44, 40],
  "1f1fa-1f1ec": [45, 40],
  "1f1fa-1f1e6": [46, 40],
  "1f1e6-1f1ea": [47, 40],
  "1f1ec-1f1e7": [48, 40],
  "1f1fa-1f1f8": [49, 40],
  "1f1fa-1f1fe": [50, 40],
  "1f1fa-1f1ff": [51, 40],
  "1f1fb-1f1fa": [52, 40],
  "1f1fb-1f1e6": [53, 40],
  "1f1fb-1f1ea": [54, 40],
  "1f1fb-1f1f3": [55, 40],
  "1f1fc-1f1eb": [56, 40],
  "1f1ea-1f1ed": [57, 40],
  "1f1fe-1f1ea": [58, 40],
  "1f1ff-1f1f2": [59, 40],
  "1f1ff-1f1fc": [60, 40],
  "1f1e6-1f1e8": [61, 40],
  "1f1f9-1f1e6": [62, 40],
  "1f1e7-1f1fb": [63, 40],
  "1f1ed-1f1f2": [0, 41],
  "1f1f8-1f1ef": [1, 41],
  "1f1fa-1f1f2": [2, 41],
  "1f1ea-1f1e6": [3, 41],
  "1f1e8-1f1f5": [4, 41],
  "1f1e9-1f1ec": [5, 41],
  "1f1f2-1f1eb": [6, 41],
  "1f1fa-1f1f3": [7, 41],
  "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f": [8, 41],
  "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f": [9, 41],
  "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f": [10, 41],
  "1f1ff": [11, 41],
  "1f1fe": [12, 41],
  "1f1fd": [13, 41],
  "1f1fc": [14, 41],
  "1f1fb": [15, 41],
  "1f1fa": [16, 41],
  "1f1f9": [17, 41],
  "1f1f8": [18, 41],
  "1f1f7": [19, 41],
  "1f1f6": [20, 41],
  "1f1f5": [21, 41],
  "1f1f4": [22, 41],
  "1f1f3": [23, 41],
  "1f1f2": [24, 41],
  "1f1f1": [25, 41],
  "1f1f0": [26, 41],
  "1f1ef": [27, 41],
  "1f1ee": [28, 41],
  "1f1ed": [29, 41],
  "1f1ec": [30, 41],
  "1f1eb": [31, 41],
  "1f1ea": [32, 41],
  "1f1e9": [33, 41],
  "1f1e8": [34, 41],
  "1f1e7": [35, 41],
  "1f1e6": [36, 41],
  "1f3fb": [37, 41],
  "1f3fc": [38, 41],
  "1f3fd": [39, 41],
  "1f3fe": [40, 41],
  "1f3ff": [41, 41]
};